'use strict';

angular.module('privacy', [
  'ngAnimate',
  'ngCookies',
  'ngSanitize',
  'ngMessages',
  'ngAria',
  'ui.router',
  'ui.bootstrap',
  'angularSoap',
  'toastr',
  'blockUI',
  'ngStorage',
  'angularMoment',
  'prettyXml',
  'frapontillo.bootstrap-switch',
  'angular.filter',
  'ui.tree',
  'pageslide-directive',
  'angulartics',
  'ngLodash',
  'uuid4',
  'angulartics.google.analytics',
  'tmh.dynamicLocale',
  'nzToggle'
]);

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.notUnique', {
    url: '/not-unique-email',
    params: {
      nextState: null,
      nextStateParams: null
    },
    templateUrl: 'app/paasLogin/notUnique/notUnique.html',
    controller: 'login_PaasloginNotUniqueController',
    controllerAs: 'login',
    resolve: {
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
})
.controller('login_PaasloginNotUniqueController', function(
) {
});

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.unknown', {
    url: '/unkown-email',
    params: {
      nextState: null,
      nextStateParams: null
    },
    templateUrl: 'app/paasLogin/unknown/unknown.html',
    controller: 'login_PaasloginUnknownController',
    controllerAs: 'login',
    resolve: {
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
})
.controller('login_PaasloginUnknownController', function(
) {
  var vm = this;
  vm.data = '';

});

'use strict';

angular.module('privacy')
  .config(function ($stateProvider) {
    $stateProvider.state('privacy.main.tab', {
      url: '/tab/:name',
      templateUrl: 'app/main/tab/tab.html',
      controller: 'main_tab_TabController',
      controllerAs: 'tab'
    });
  })
  .controller('main_tab_TabController', function (
    $state, $rootScope, $localStorage, Relen, $analytics, CustomElements, $stateParams
  ) {
    var name = $stateParams.name;
    var vm = this;

    function getExtraTab() {
      var found = false;
      vm.tab = [];
      vm.table = [];
      vm.headers = [];
      vm.rows = [];
      CustomElements.getData().then(function (data) {
        if (data.hasOwnProperty('extra_tabs')) {
          if (data.extra_tabs.hasOwnProperty($localStorage['locale'])) {
            var value = angular.fromJson(data.extra_tabs[$localStorage['locale']]);
            angular.forEach(value, function (val) {
              if (val.hasOwnProperty('checkbox') && val.checkbox && name === val.name) {
                found = true;
                Relen.paaSGetTab(val.name).then(function (result) {
                  var jsonData = angular.fromJson(result.data.jsonData);
                  vm.headers = jsonData.definition.headers;
                  vm.rows = jsonData.data.rows;
                });
                vm.tab = val;
              }
            });
          }
        }

        if (!found) {
          $state.go('privacy.main.data');
        }

      });
    }

    getExtraTab();

    var watcher = $rootScope.$on('languageChanged', function () {
      getExtraTab();
    });

    $rootScope.$on('$destroy', function () {
      watcher();
    })

  });

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.main.permissions', {
    url: '/permissions',
    templateUrl: 'app/main/permissions/permissions.html',
    controller: 'main_permissions_DataController',
    controllerAs: 'permissions',
    resolve: {
      acl: function(ErrorService, Auth) {
        return Auth.checkAccessList('PAAS/Permissions');
      }
    }
  });
})
.controller('main_permissions_DataController', function(
  Relen, acl, App, $state, CustomElements, $localStorage, $analytics, t, $rootScope, $q
) {

  if (!acl) {
    return $state.go('privacy.main.data');
  }

  var vm = this;

  vm.permissions = [];
  vm.permissionsGood = {};
  vm.permissionsCategory = {};
  vm.singlePermissions = {};
  var allChannels = [];
  var allPermissions = [];
  var found = false;
  vm.useCategories = false;
  vm.showGroupsToggle = false;
  vm.GroupsToggleState = false;

  function setPermissions() {
    vm.permissions = [];
    vm.permissionsGood = {};

    for (var index = 0; index < App.contact.ContactPermissions.length; index++) {
      var permission = App.contact.ContactPermissions[index];

      if(angular.isDefined(permission.inOut)) {
        permission.inOut = permission.inOut[0];

        if (permission.inOut === '?') {
          permission.hide = "true";
        } else {
          permission.hide = "false";
        }

        vm.permissions.push(permission);
      }

    }
    var string = "";
    angular.forEach(vm.permissions, function(value) {
      if (angular.isUndefined(vm.permissionsGood[value.cbpCode.toString()])) {
        vm.permissionsGood[value.cbpCode.toString()] = {};
        string = 'permission_channel.' + value.channelCode.toString();
        value.translation = string;
        value.icon = 'permission_channel_icon.' + value.channelCode.toString(),


        vm.permissionsGood[value.cbpCode.toString()] = {
          code : value.cbpCode.toString(),
          key : 'permission_info_text.' + value.cbpCode.toString(),
          title : t('permission_info_title.' + value.cbpCode.toString()),
          data : []
        };
        vm.permissionsGood[value.cbpCode.toString()].data.push(value);
      } else {
        string = 'permission_channel.' + value.channelCode.toString();
        value.translation = string;
        value.icon = 'permission_channel_icon.' + value.channelCode.toString(),
        vm.permissionsGood[value.cbpCode.toString()].data.push(value);
      }
    });

    angular.forEach(allChannels, function(value) {
      string = 'permission_channel.' + value.channelCode.toString();
      value.translation = string;
      value.icon = 'permission_channel_icon.' + value.channelCode.toString(),
      value.hide = "unkown";
      angular.forEach(vm.permissionsGood, function(item) {
        found = false

        angular.forEach(allPermissions,function(per) {
          if(item.code === per.cbpCode.toString()) {
            var key = 'description_' + $localStorage['locale'];
            item.fallbackTitle = per[key];
          }
        });

        angular.forEach(item.data, function(data) {
          if(data.channelCode.toString() === value.channelCode.toString()) {
            found = true;
          }
        });
        if(!found) {
          item.data.push(value);
        }
        item.data.sort(function (a, b) {
          var nameA = a.channelCode.toString(); // ignore upper and lowercase
          var nameB = b.channelCode.toString(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      });
    });

    angular.forEach(vm.permissionsGood, function(item) {
      var dataGood = [];
      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'DM') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'EM') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'PH') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'SMS') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'APP') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'OTH') {
          dataGood.push(d);
        }
      });

      angular.forEach(item.data, function(d) {
        if (d.channelCode.toString() === 'WEB') {
          dataGood.push(d);
        }
      });

      item.data = dataGood;
     });
    createGroups();
  }

  vm.colors = {
    true : "#000",
    false : "#000"
  };

  vm.toggle = {
    good : "I",
    bad : "O",
    unkwon: "?",
    disabled: "?",
    updated : false
  }

  CustomElements.getData().then(function(data) {
    if(data) {
      if(data.hasOwnProperty('toggle_false')){
        vm.toggle.updated = true;
        vm.colors.false = data['toggle_false'];
      }
      if(data.hasOwnProperty('toggle_true')){
        vm.toggle.updated = true;
        vm.colors.true = data['toggle_true'];
      }
    }
    vm.toggle.updated = true;

    Relen.getAllPossiblePermissions($localStorage['client']).then(function(data) {
      allChannels = [];
      allPermissions = [];
      allChannels = data.PaaSChannelCodes;
      allPermissions = data.PaaSPermissions;
      setPermissions();
    });

  });

  vm.editPermission = function(permission) {
    var data = {
      cbpID : permission.cbpID,
      channelCode: permission.channelCode.toString(),
      inOut: permission.inOut.toString()
    };

    Relen.updatePermission(data).then(function() {
      App.refreshContact().then(function() {
        setPermissions();
      });
    });
  }

  vm.tracking = function() {
    $analytics.eventTrack('hit', {  category: 'Company CTA', label: $localStorage['client'] });
  };

  var watcher = $rootScope.$on('languageChanged', function() {
    setPermissions();
  });

  $rootScope.$on('$destroy', function() {
    watcher();
  });

  function createGroups() {
    var result = [];
    var singleStates = {};
    CustomElements.getData().then(function(data) {
      if (data.hasOwnProperty('category_permission')) {
        var categories = angular.fromJson(data['category_permission']);
        if(categories.length > 0) {
          vm.useCategories = true;
          angular.forEach(categories, function(value) {
            var title = "";
            var description ="";
            var fallbackTitle = "";

            if (value.permission_code !== "") {
              angular.forEach(allPermissions,function(per) {
                if(value.permission_code === per.cbpCode.toString()) {
                  var key = 'description_' + $localStorage['locale'];
                  fallbackTitle = per[key]
                }
              });

              title = t('permission_info_title.' + value.permission_code);
              description =  t('permission_info_text.' + value.permission_code);

            }

            if(value.hasOwnProperty($localStorage['locale']) && value[$localStorage['locale']] !== '') {
              result.push({
                title: unescape(value[$localStorage['locale']]),
                description: unescape(value[$localStorage['locale'] + "_description"]),
                key: value.title,
                state: '?',
                childeren: {},
                show: true,
                checkbox: value.checkbox,
                permission_code: value.permission_code,
                data : {},
                title_permission : title ,
                description_permission : description,
                fallbackTitle : fallbackTitle
              });
            }
          });

          if (data.hasOwnProperty('permission_category')) {
            angular.forEach(result, function(value) {
              angular.forEach(data['permission_category'], function(item, key){
                if(value.key === item) {
                  value.childeren[key] = [];
                }

                if (item === 'single-state') {
                  singleStates[key] = [];
                }

                if ('cbpCode_' + value.permission_code === item) {
                  value.childeren[key] = [];
                }

              });
              if(angular.equals(value.childeren, {})) {
                value.show = false;
              }
            });
          }

          angular.forEach(result, function(value) {
            angular.forEach(value.childeren, function(item, key) {
              angular.forEach(vm.permissionsGood, function(data, k){
                if (key === k) {
                  value.childeren[key] = data;
                }
              });
            });

            if(value.permission_code !== '') {
              angular.forEach(vm.permissionsGood, function(data, k){
                if (value.permission_code === k) {
                  value.data = data;
                }
              });
            }
          });

          if (Object.keys(singleStates).length > 0) {
            angular.forEach(singleStates, function(value, key) {
              angular.forEach(vm.permissionsGood, function(data, k){
                if (key === k) {
                  singleStates[key] = data;
                }
              });
            });
          }
        }
      }

      vm.permissionsCategory = result;
      vm.singlePermissions = singleStates;
    });
  }

  vm.editPermissionGroup = function(category) {
    var promises = [];
    angular.forEach(category.childeren, function(value){
      angular.forEach(value.data, function(item){
        if(angular.isDefined(item.cbpID)) {
          var data = {
            cbpID : item.cbpID,
            channelCode: item.channelCode.toString(),
            inOut: category.state.toString()
          };
          promises.push(Relen.updatePermission(data));
        }
      });
    });

    if(Object.keys(category.data).length > 0) {
      angular.forEach(category.data.data, function(item){
        if(angular.isDefined(item.cbpID)) {
          var data = {
            cbpID : item.cbpID,
            channelCode: item.channelCode.toString(),
            inOut: category.state.toString()
          };
          promises.push(Relen.updatePermission(data));
        }
      });
    }

    /*eslint angular/no-services: [2,["q"]]*/
    $q.all(promises).then(function(){
      App.refreshContact().then(function() {
        setPermissions();
      });
    });
  }

});

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.main.data', {
    url: '/data',
    templateUrl: 'app/main/data/data.html',
    controller: 'main_data_DataController',
    controllerAs: 'data',
    resolve: {
      acl: function(ErrorService, Auth) {
        return Auth.checkAccessList('PAAS/Data');
      }
    }
  });
})
.controller('main_data_DataController', function(
  Relen, acl, Ref, SidePanel, App, t, $state, ConfirmationService, $analytics,
  $localStorage, toastr, $rootScope, CustomElements
) {

  if (!acl) {
    return $state.go('privacy.main.permissions');
  }

  var vm = this;

  vm.genders = [];
  vm.touchPoints = [];
  vm.mainTypes = [];
  vm.subTypes = [];
  vm.showSubtypes = false;
  angular.forEach(App.reltpCombinations.map, function(item) {
    angular.forEach(item, function(data){
      if (data.tpSubCode !== '') {
        vm.showSubtypes = true;
      }
    });
  });

  function loadTouchpoints() {
    vm.touchPoints = [];
    vm.mainTypes = [];
    vm.subTypes = [];

    CustomElements.getData().then(function(data) {
      if (data.hasOwnProperty('modify_data')) {
        var modify_data = angular.fromJson(data.modify_data);
        angular.forEach(App.contact.ContactRelationTouchPoints, function(item) {
          angular.forEach(modify_data, function(value) {
            if (item.hasOwnProperty('reltpSubCode')) {
              var name = item.reltpCode.toString() + '_'  + item.reltpSubCode.toString()
              if (value.name === name) {
                item.modify = value.modify;
                item.delete = value.delete;
              }
            } else {
              if (value.name === item.reltpCode.toString()) {
                item.modify = value.modify;
                item.delete = value.delete;
              }
            }
          })
          vm.touchPoints.push(item);
        });
      } else {
        vm.touchPoints = App.contact.ContactRelationTouchPoints;
      }
    });

    angular.forEach(App.reltpCodes.map, function(item) {
      CustomElements.getData().then(function(data) {
        if (data.hasOwnProperty('modify_data')) {
          var modify_data = angular.fromJson(data.modify_data);
          angular.forEach(modify_data, function(value) {
            if(value.name.indexOf(item.reltpCode) !== -1 && value.create && !vm.mainTypes.includes(item)) {
              vm.mainTypes.push(item);
              vm.subTypes[item.reltpCode] = [];
            }
          });
        }
      });
    });

    angular.forEach(App.reltpCombinations.map, function(item) {
      angular.forEach(item, function(i){
        CustomElements.getData().then(function(data) {
          if (data.hasOwnProperty('modify_data')) {
            var modify_data = angular.fromJson(data.modify_data);
            angular.forEach(modify_data, function(value) {
              if (i.tpSubCode !== '') {
                var name = i.tpCode + '_' + i.tpSubCode;
                if(name === value.name && value.create) {
                  vm.subTypes[i.tpCode].push(i);
                }
              } else {
                if(i.tpCode === value.name && value.create) {
                  vm.subTypes[i.tpCode].push(i);
                }
              }
            });
          }
        });
      });
    });
  }

  loadTouchpoints();

  vm.getSubTypes = function(type) {
    return vm.subTypes[type];
  }

  function getGenderslocal() {
    vm.genders = [];
    Ref.genders().then(function(result) {
      angular.forEach(result, function(value, key){
        if (value.inGUIDropDown === 'true') {
          vm.genders.push(value);
        }

        if (key === '*' && App.contact.ContactIndividualEntity.genderCode.valueOf() === key ) {
          vm.genders.push(value);
        }
      });
      setUser();
    });
  }

  getGenderslocal();

  vm.touchPointsOrder = function(tp) {
    switch (tp.reltpCode.valueOf()) {
      case 'POST': return 1;
      case 'EMAIL': return 2;
      case 'MOB': return 3;
      case 'PHONE': return 4;
      case 'FAX': return 5;
      default: return 100;
    }
  };

  vm.getLegalCode = function getLegalCode(code) {
    var value = code.valueOf();
    if (angular.isObject(value)) {
      value = '';
    }

    return value;
  }

  vm.touchpointValue = function(tp) {
    if (!tp) {
      return '';
    }

    switch (tp.reltpCode.valueOf()) {
      case 'POST': return address(tp);
      case 'MOB':
      case 'PHONE':
      case 'EMAIL': // no special action
      default: return tp.value;
    }
  };

  vm.sideIndividu = {
    firstName: App.contact.ContactIndividualEntity.firstName,
    familyName: App.contact.ContactIndividualEntity.familyName,
    dob: null,
    languageCode: null,
    genderCode: null,
    titleCode: null,
    conieID: App.contact.ContactIndividualEntity.conieID
  };

  function setUser() {
    if (App.contact.ContactIndividualEntity.dob) {
      vm.sideIndividu.dob = new Date(App.contact.ContactIndividualEntity.dob);
    }

    if (App.contact.ContactIndividualEntity.languageCode) {
      vm.sideIndividu.languageCode = App.contact.ContactIndividualEntity.languageCode.toString();
    }

    if (App.contact.ContactIndividualEntity.genderCode) {
      vm.sideIndividu.genderCode = App.contact.ContactIndividualEntity.genderCode.valueOf();
    }

    if (App.contact.ContactIndividualEntity.titleCode) {
      vm.sideIndividu.titleCode = App.contact.ContactIndividualEntity.titleCode.valueOf();
    }

    angular.forEach(vm.genders, function(value) {
      if (vm.sideIndividu.genderCode === value.genderCode) {
        vm.sideIndividu.genderDescription  = value.description;
      }
    });

    var key = vm.sideIndividu.titleCode;
    var gender = vm.sideIndividu.genderCode;
    var language =  $localStorage['locale'];
    if (App.titles.map[key] && App.titles.map[key][gender] && App.titles.map[key][gender][language]) {
        vm.sideIndividu.titleDescription = App.titles.map[key][gender][language].salutation;
    }

  }

  setUser();

  vm.sideTitles = function() {
    var titles = [];
    var gender = vm.sideIndividu.genderCode;
    var language = vm.sideIndividu.languageCode;

    for (var key in App.titles.map) {
      if (App.titles.map[key] && App.titles.map[key][gender] && App.titles.map[key][gender][language]) {
          titles.push(App.titles.map[key][gender][language]);
      }
    }

    return titles;
  }

  vm.editIndividu = function() {
    Relen.updateIndividual(angular.copy(vm.sideIndividu)).then(function() {
      App.refreshContact().then(function() {
        getGenderslocal();
        toastr.success(t('my_data_contact_successful_update'));
        loadTouchpoints();
      });
    });
  }

  vm.reltpCodes = [];
  vm.createSideTouchpoint = function() {
    vm.sideTouchpoint = {
      reltpSubCode: '',
      reltpStatusCode: 'V',
      ContactAddress: {
        countryCode: 'BE'
      }
    };
  };

  vm.getTouchpointForm = function(tp) {
    var directory = 'app/main/data/forms/';
    var file = 'post';
    vm.sideTouchpointLabel = null;
    if (tp) {
      var reltpCode = tp.reltpCode;
      if (angular.isObject(reltpCode)) {
        reltpCode = reltpCode.valueOf();
      }

      switch (reltpCode) {
        case 'POST':
          file = 'post';
          break;
        case 'EMAIL':
          vm.sideTouchpointLabel = t('contacts_touchpoints_manage_touchpoint_email');
          file = 'default';
          break;
        case 'MOB':
          vm.sideTouchpointLabel = t('contacts_touchpoints_manage_touchpoint_mob');
          file = 'default';
          break;
        case 'PHONE':
          vm.sideTouchpointLabel = t('contacts_touchpoints_manage_touchpoint_phone');
          file = 'default';
          break;
        case 'FAX':
          vm.sideTouchpointLabel = t('contacts_touchpoints_manage_touchpoint_fax');
          file = 'default';
          break;
        default:
          vm.sideTouchpointLabel = t('contacts_touchpoints_manage_touchpoint_value');
          file = 'default';
          break;
      }
    }

    return directory + file + '.html';
  };

  vm.createTouchpoint = function() {
    var data = {};
    var method;
    if (vm.sideTouchpoint.reltpCode === 'POST') {
      data = {
        reltpSubCode: vm.sideTouchpoint.reltpSubCode,
        reltpCode: vm.sideTouchpoint.reltpCode,
        street: vm.sideTouchpoint.ContactAddress.street,
        streetHouseNumber: vm.sideTouchpoint.ContactAddress.streetHouseNumber,
        postalCode: vm.sideTouchpoint.ContactAddress.postalCode,
        city: vm.sideTouchpoint.ContactAddress.city,
        countryCode: vm.sideTouchpoint.ContactAddress.countryCode
      };

      method = 'addPostTouchpoint';

      if (vm.sideTouchpoint.ContactAddress.streetComplement) {
        data.streetComplement = vm.sideTouchpoint.ContactAddress.streetComplement;
      }
    } else {
      data = {
        value: vm.sideTouchpoint.value,
        reltpCode: vm.sideTouchpoint.reltpCode,
        reltpSubCode: vm.sideTouchpoint.reltpSubCode
      };

      method = 'addTouchpoint';
    }

    Relen[method](data).then(function() {
      App.refreshContact().then(function(){
        loadTouchpoints();
      });
      vm.sideTouchpoint = {};
      SidePanel.closeAll();
    });
  };

  vm.editTouchpoint = function() {
    var data = {};
    var method;

    if (vm.sideTouchpoint.reltpCode === 'POST') {
      data = {
        reltpID: vm.sideTouchpoint.reltpID,
        reltpSubCode: vm.sideTouchpoint.reltpSubCode,
        reltpCode: vm.sideTouchpoint.reltpCode,
        street: vm.sideTouchpoint.ContactAddress.street,
        streetHouseNumber: vm.sideTouchpoint.ContactAddress.streetHouseNumber,
        postalCode: vm.sideTouchpoint.ContactAddress.postalCode,
        city: vm.sideTouchpoint.ContactAddress.city,
        countryCode: vm.sideTouchpoint.ContactAddress.countryCode
      };

      method = 'updatePostTouchpoint';

      if (vm.sideTouchpoint.ContactAddress.streetComplement) {
        data.streetComplement = vm.sideTouchpoint.ContactAddress.streetComplement;
      }
    } else {
      data = {
        reltpID: vm.sideTouchpoint.reltpID,
        value: vm.sideTouchpoint.value,
        reltpCode: vm.sideTouchpoint.reltpCode,
        reltpSubCode: vm.sideTouchpoint.reltpSubCode
      };

      method = 'updateTouchpoint';
    }

    Relen[method](data).then(function() {
      App.refreshContact().then(function(){
        loadTouchpoints();
        vm.sideTouchpoint = {};
        SidePanel.closeAll();
      });
    });
  };

  vm.showReltpSubCodes = function(reltpCode) {
    if (App.reltpCombinations.get(reltpCode)) {
      var combinations = App.reltpCombinations.get(reltpCode).filter(function(val) {
        return val.tpSubCode !== '';
      });
      return combinations.length != 0;
    }

    return false;
  };

  vm.editSideTouchpoint = function editSideTouchpoint(tp) {
    vm.sideTouchpoint = angular.extend({}, tp);
    if (angular.isUndefined(vm.sideTouchpoint.reltpSubCode)) {
      vm.sideTouchpoint.reltpSubCode = '';
    } else {
      vm.sideTouchpoint.reltpSubCode = tp.reltpSubCode.toString();
    }
    vm.sideTouchpoint.reltpCode = vm.sideTouchpoint.reltpCode.valueOf();

    vm.sideTouchpoint.ContactAddress = angular.extend({}, tp.ContactAddress);

    if (tp.ContactAddress && tp.ContactAddress.hasOwnProperty('countryCode')) {
          vm.sideTouchpoint.ContactAddress.countryCode = tp.ContactAddress.countryCode.valueOf();
    }
  };

  vm.deleteTouchpoint = function deleteTouchpoint(tp) {
    var info = null;

    if (App.contact.ContactRelationTouchPoints.length === 1) {
      info = t('contacts_touchpoints_delete_last');
    }

    ConfirmationService.confirmRemove(
      t('contacts_touchpoints_delete_confirmation'),
      info
    ).then(function() {
      Relen.deleteTouchpoint(tp.reltpID).then(function() {
        App.refreshContact().then(function(){
          loadTouchpoints();
        });
      });
    })
  };

  function replaceByEmptyString(value) {
    if (value === null || angular.isUndefined(value) || !value) {
      value = '';
    }

    return value;
  }

  function street(tp) {
    if (!tp || !tp.ContactAddress) {
      return '';
    }
    var ca = tp.ContactAddress;
    return replaceByEmptyString(ca.street) + ' ' +
      replaceByEmptyString(ca.streetHouseNumber) +
      ((replaceByEmptyString(ca.streetComplement))?
        ' ' + replaceByEmptyString(ca.streetComplement):
        ''
      )
  }

  function city(tp) {
    if (!tp || !tp.ContactAddress) {
      return '';
    }
    var ca = tp.ContactAddress;

    var country = replaceByEmptyString(ca.countryCode);
    if (country !== '') {
      country = ca.countryCode['@description'];
    }

    return (replaceByEmptyString(ca.postalCode) + ' ' + replaceByEmptyString(ca.city) + ((ca.postalCode || ca.city)? ', ': '') + country).trim();
  }

  function address(tp) {
    if (!tp) {
      return '';
    }

    return [street(tp), city(tp)]
      .filter(function(str) { return str.trim() !== ''; })
      .join(', ');
  }

  vm.tracking = function() {
    $analytics.eventTrack('hit', {  category: 'Company CTA', label: $localStorage['client'] });
  };

  var watcher = $rootScope.$on('languageChanged', function() {
    getGenderslocal();
    setUser();
  });

  $rootScope.$on('$destroy', function() {
    watcher();
  })


});

'use strict';

angular.module('privacy')
  .config(function ($stateProvider) {
    $stateProvider.state('privacy.main.faq', {
      url: '/faq',
      templateUrl: 'app/main/faq/faq.html',
      controller: 'main_faq_FaqController',
      controllerAs: 'faq',
      resolve: {
        acl: function (Auth) {
          return Auth.checkAccessList('PAAS/Faq');
        }
      }
    });
  })
  .controller('main_faq_FaqController', function (
    acl, $state, $rootScope, $localStorage, Relen, $analytics, CustomElements
  ) {

    if (!acl) {
      return $state.go('privacy.main.data');
    }

    var vm = this;
    vm.tabs = [];
    vm.description = "";
    vm.title = "";

    function getFaqs() {
      CustomElements.getData().then(function(data) {
        if (data.hasOwnProperty('faq')) {
          if (data.faq.hasOwnProperty($localStorage['locale'])) {
            var value = angular.fromJson(data.faq[$localStorage['locale']]);
            if(value.length > 0) {
              angular.forEach(value, function(item) {
                item.title_tab = unescape(item.title);
              });
              vm.tabs = value;
              vm.title = unescape(value[0].title);
              vm.description = unescape(value[0].description);
            } else {
              vm.dashboards = [];
            }
          } else {
            vm.dashboards = [];
          }
        }
      });
    }
  
    getFaqs();

    vm.openTab = function(tab) {
      vm.title = unescape(tab.title);
      vm.description = unescape(tab.description);
    }

    var watcher = $rootScope.$on('languageChanged', function () {
      getFaqs();
    });

    $rootScope.$on('$destroy', function () {
      watcher();
    })

    vm.tracking = function () {
      $analytics.eventTrack('hit', {
        category: 'Company CTA',
        label: $localStorage['client']
      });
    };

  });

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.logout', {
    url: '/logout',
    params: {
      nextState: null,
      nextStateParams: null
    },
    templateUrl: 'app/login/logout/logout.html',
    controller: 'login_LogoutController',
    controllerAs: 'logout',
    resolve : {
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
})
.controller('login_LogoutController', function() {});

'use strict'

angular.module('privacy')
.directive('validationTooltip', function($compile) {
  return {
    restrict: 'A',
    scope: {
        form: '=validationTooltip'
    },
    link: function($scope, element) {
      var invalidWatch = $scope.$watch('form.$invalid', function(invalid) {
        element.prop('disabled', invalid);
      }, true);
      var errorsWatch = $scope.$watch('form.$error', function(errors) {
        validationTooltip(errors);
      }, true);

      $scope.$on('$destroy', function() {

        invalidWatch();
        errorsWatch();
      });

      function validationTooltip(errors) {
        var triangle = element.next('span.btn-attention[uib-tooltip]');

        if ($scope.form.$invalid) {
          // create or update triangle with errors in tooltip, but remove old triangles first
          if (triangle.length > 0) {
            triangle.remove();
          }

          triangle = angular.element('<span class="btn-attention pull-right"><i class="sta-warning"></i></span>');
          triangle.attr('uib-tooltip', tooltipContent(errors));
          element.after($compile(triangle)($scope));
        } else if (triangle.length > 0) {
          // remove triangle if it exists
          triangle.remove();
        }
      }

      function tooltipContent(errorsByType) {
        var tooltips = [];

        for (var type in errorsByType) {
          if (errorsByType.hasOwnProperty(type)) {
            var errors = errorsByType[type];

            for (var i = 0; i < errors.length; i++) {
              var error = errors[i];
              element.parent('form').find('label[for="' + error['$name'] + '"]').html()
              var label = (element.parent('form').find('label[for="' + error['$name'] + '"]').html() || error['$name']);

              if (tooltips.indexOf(label) === -1) {
                tooltips.push(label);
              }
            }
          }
        }
        return tooltips.join(', ');
      }

    }
  };
});

'use strict';

angular.module('privacy')
  .config(function ($stateProvider) {
    $stateProvider.state('privacy.codeCheck', {
      url: '/code/:token',
      params: {
        nextState: null,
        nextStateParams: null
      },
      templateUrl: 'app/login/codeCheck/codeCheck.html',
      controller: 'login_CodeController',
      controllerAs: 'code',
      resolve: {
        CUSTOMTRANSLATIONS: function (CustomTranslations) {
          return CustomTranslations.promise();
        },
        CUSTOM2TRANSLATIONS: function (CustomTranslations) {
          return CustomTranslations.promise2();
        },
        CUSTOMSTYLE: function (CustomElements) {
          return CustomElements.promise();
        }
      }
    });
  })
  .controller('login_CodeController', function (
    $state, $stateParams, Auth, $location, t, $localStorage, toastr, $analytics,
    $sessionStorage, PRIVACYVERSION
  ) {
    if (angular.isDefined($sessionStorage['loged_in'])) {
      $state.go('privacy.main.data');
    }

    var vm = this;
    vm.data = "";
    vm.privacyVersion = PRIVACYVERSION;

    if (!$stateParams.hasOwnProperty('token')) {
      $state.go('privacy.notAuthorized');
    }

    if (angular.isUndefined($localStorage['client'])) {
      $state.go('privacy.login', {
        token: $stateParams.token
      });
    }

    vm.checkCode = function checkCode() {
      if (vm.data != "") {
        Auth.doLoginWithCode($stateParams.token, vm.data).then(function (data) {
          $analytics.eventTrack(
            'hit', {
              category: 'Login CTA',
              label: $localStorage['client']
            }
          );

          if (data.token) {
            var searchParams = $location.search();
            if (searchParams.hasOwnProperty('language')) {
              t.setLanguage(searchParams.language);
            }
            $state.go('privacy.main.data');
          } else {
            $state.go('privacy.notAuthorized');
          }
        }).catch(function () {
          $state.go('privacy.notAuthorized');
        });
      } else {
        toastr.error(t('codecheck_please_fill_in_your_code'));
      }
    }

    vm.newCode = function () {
      Auth.getTokenInfo($stateParams.token);
    }
  });

'use strict'

angular.module('privacy')
.service('Util',function(
  $sessionStorage, $q, $log, moment
) {

  var vm = {};

  vm.createNotifier = function() {
    var notifier = {};
    notifier.listeners = {};

    var handle = 0;

    notifier.listen = function(listener) {
      if(!angular.isFunction(listener)) {
        throw new Error('notifier expects listener to be a function');
      }
      notifier.listeners[handle] = listener;
      return handle++;
    };

    notifier.detach = function(handle) {
      delete notifier[handle];
    };

    notifier.notify = function() {
      var args = Array.prototype.slice.call(arguments);
      Object.keys(notifier.listeners).forEach(function(handle) {
        notifier.listeners[handle].apply(null, args);
      });
    };

    return notifier;
  };

  vm.deepCompare = function(given,expected) {
    // leaf node
    if(!angular.isObject(given)) {
      return given === expected;
    }
    // expected leaf node but got object
    else if(!angular.isObject(expected)) {
      return false;
    }
    // recursively check all children
    else {
      return Object.keys(given).every(function(child) {
        return vm.deepCompare(given[child],expected[child]);
      });
    }
  };

  vm.createSessionCache = function(timeout, unit, cacheKey) {
    var cache = {};

    cache.store = function(result, meta) {
      // don't store an already cached result
      if(result.$cached) {
        return false;
      }
      $sessionStorage[cacheKey] = {
        result: result,
        when: moment(),
        meta: meta
      };
      return true;
    };

    cache.get = function(expectedMeta) {
      var stored = $sessionStorage[cacheKey];
      // check if there is something in the cache
      if(!stored) {
        $log.debug('cache[%s] miss', cacheKey);
        return false;
      }
      // check if the cached result is too old
      var when = moment(stored.when);
      var maxAge = moment().subtract(timeout, unit);
      if(when.diff(maxAge) < 0) {
        $log.debug('cache[%s] miss - age check failed', cacheKey);
        return false;
      }
      // check meta info if needed
      if(expectedMeta && !vm.deepCompare(stored.meta, expectedMeta)) {
        $log.debug('cache[%s] miss - meta check failed', cacheKey);
        return false;
      }
      $log.debug('cache[%s] hit', cacheKey);
      // mark the result as cached
      stored.result.$cached = true;
      // attach a resolved promise to the result
      stored.result.$promise = $q.resolve(stored.result);
      // return the result
      return stored.result;
    };

    return cache;
  };

  vm.identityMap = function(arr) {
    var map = {};
    arr.forEach(function(el) {
      map[el] = el;
    });
    return map;
  };

  vm.mapArray = function(arr, key) {
    var map = {};
    arr.forEach(function(obj) {
      map[obj[key]] = obj;
    });
    return map;
  };

  vm.qReject = function(reason) {
    return $q.reject(reason);
  };

  vm.collectionIndexOnKey = function(collection, obj, key) {
    if(!angular.isArray(collection)) {
      return -1;
    }
    for(var idx = 0; idx < collection.length; idx++) {
      var o = collection[idx];
      if(o === obj || o[key] === obj[key]) {
        return idx;
      }
    }
    return -1;
  };

  return vm;

});

'use strict';

angular.module('privacy')
.service('Phone', function($window) {
  var vm = {};

  // make all methods from phoneformat.js available
  // https://github.com/albeebe/phoneformat.js
  [ 'countryForE164Number',
    'formatNumberForMobileDialing',
    'isValidNumber',
    'formatE164',
    'formatInternational',
    'formatLocal',
    'exampleLandlineNumber',
    'exampleMobileNumber',
    'cleanPhone',
    'countryCodeToName'
  ].forEach(function(method) {
    vm[method] = $window[method];
  });

  return vm;
})
// make the service available in via $rootScope
.run(function($rootScope, Phone) {
  $rootScope.PHONE = Phone;
});

'use strict';

angular.module('privacy')
.filter('jsonsoap',function($window) {
  function toJsonSoap(obj, pretty) {
    if (typeof obj === 'undefined') {
      return undefined;
    }
    if (!angular.isNumber(pretty)) {
      pretty = pretty ? 2 : null;
    }
    return $window.JSON.stringify(obj, jsonSoapReplacer, pretty);
  }
  function jsonSoapArgs(obj) {
    var args = Object.keys(obj)
    // keep only non-numeric keys
    .filter(function(k) {
      return isNaN(k);
    })
    // create "@key = value" pairs
    .map(function(k) {
      return k + ' = ' + obj[k];
    });
    return args.length > 0 ?
      ' [' + args.join(', ') + ']' : '';
  }
  function jsonSoapReplacer(_key, val) {
    if(
      val instanceof Number ||
      val instanceof String ||
      val instanceof Boolean
    ) {
      return '' + val.valueOf() + jsonSoapArgs(val);
    }
    return val;
  }

  return function(object, spacing) {
    if (angular.isUndefined(spacing)) {
        spacing = 2;
    }
    return toJsonSoap(object, spacing);
  };
});

'use strict'

angular.module('privacy')
.service('t',function(
  CustomTranslations, $interpolate, $localStorage, tmhDynamicLocale, API, $rootScope, $document
) {

  function replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
  }

  function t(key, custom, variables) {
    if(key) {
      var translatedValue = "";
      if(
        key.indexOf('permission_channel.') !== -1 ||
        key.indexOf('permission_info_text.') !== -1 ||
        key.indexOf('permission_info_title.') !== -1 ||
        key.indexOf('permission_channel_icon.') !== -1
      ) {
        var text = key.split(".");
        translatedValue = CustomTranslations.getCustom(text[0], text[1]);
      } else {
        translatedValue = CustomTranslations.get(key, custom);
      }

      if(key.indexOf('permission_channel_icon.') !== -1) {
        return translatedValue;
      }


      if (translatedValue) {
        var translation = translatedValue[vm.language];
        if (translation === "" || angular.isUndefined(translation) || translation === null) {
          if(key.indexOf('permission_info_text.') !== -1) {
            var element = angular.element($document[0].getElementById(key) );
            element.addClass('hide');
            return '';
          }
          if(key.indexOf('permission_info_title.') !== -1) {
            return '';
          }
          return '[' + key + ']';

        }

        return $interpolate(translation)(variables);
      } else {
        if (variables) {
          key = replaceAll(key, '{', '{{');
          key = replaceAll(key, '}', '}}');
          key = $interpolate(key)(variables);
        }

        return '[' + key + ']';
      }
    }
  }

  var vm = t;

  vm.setLanguage = function(language) {
    vm.language = language;
    tmhDynamicLocale.set(language);
    $localStorage['locale'] = language;
    API.setLanguage(language).then(function() {
      $rootScope.$broadcast('languageChanged', language);
    });
  };

  if (!$localStorage['locale']) {
    vm.setLanguage('en');
  } else {
    vm.setLanguage($localStorage['locale']);
  }

  vm.getLanguages = function getLanguages() {
    return CustomTranslations.get('available_languages');
  };

  return vm;

})
.service('CustomTranslations', function($http, $localStorage) {
  var translations = {},
      customTranslations = {},
      combinedTranslations = {},
      vm = {};

  vm.promise = function() {
    return $http.get('translations.json').success(function(data) {
      translations = data;
      return translations;
    });
  };

  vm.promise2 = function promise2() {
    return $http.get('customizations/' + $localStorage['client'] + '.json').success(function(data) {
      if(data !== null) {
        customTranslations = data;
        return customTranslations;
      }
    });
  };

  vm.get = function get(key) {
    combinedTranslations = {};
    combinedTranslations = $.extend({},translations,customTranslations);

    if (combinedTranslations.hasOwnProperty(key)) {
      return combinedTranslations[key];
    }

    return false;
  }

  vm.getCustom = function getCustom(key, value) {
    combinedTranslations = {};
    combinedTranslations = $.extend({},translations,customTranslations);

    if (combinedTranslations.hasOwnProperty(key)) {
      if(combinedTranslations[key].hasOwnProperty(value)) {
        return combinedTranslations[key][value];
      }
    }

    return false;
  }

  return vm;
});

'use strict'

angular.module('privacy')
.directive('tk',function() {
  return {
    restrict: 'EA',
    replace: false,
    template: '<span>{{vm.t(vm.key)}}</span>',
    scope: {
        key: '@',
        tk: '@'
    },
    controller: function(t, $scope) {
      var vm = this;
      vm.t = t;
      vm.key = $scope.tk || $scope.key;
    },
    controllerAs: 'vm'
  };
})
.directive('langSwitch', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'app/components/translation/lang-switch.html',
    controller: function(t, $scope) {
      var vm = this;
      vm.locale = t.language;
      vm.languages = t.getLanguages();
      vm.languagesCount = Object.keys(vm.languages).length;

      var languageWatch = $scope.$watch(function() {
        return t.language;
      }, function() {
        vm.languages = t.getLanguages();
        vm.locale = t.language;
      });

      $scope.$on('$destroy', function() {
        languageWatch();
      });

      vm.setLanguage = function setLanguage(loc) {
        t.setLanguage(loc);
      }
    },
    controllerAs: 'lang'
  };
});

(function() {
  angular
    .module('privacy')
    .directive('toggleside', toggleside);

  /** @ngInject */
  function toggleside($window, $timeout) {
    var directive = {
        link: link
    };
    return directive;

    /** @ngInject */
    function link() {
      angular.element('.js-toggle-nav').click(function(event) {
        event.preventDefault();
        angular.element('.js-module-nav').toggleClass('js-module-nav--toggle');
        angular.element('.js-module-content').toggleClass('js-module-content--toggle');
        $timeout(function() {
            angular.element($window).trigger('resize',true);
          }, 250);
      });

      angular.element('body').on('click','.js-module-subnav ul > li > a',function() {
        if ($window.innerWidth <= 1050) {
          angular.element('.js-module-nav').addClass('js-module-nav--toggle');
          angular.element('.js-module-content').addClass('js-module-content--toggle');
          $timeout(function() {
            angular.element($window).trigger('resize',true);
          }, 250);
        }
      });

      //angular.element($window).bind('resize', function() {
        $window.resizeEvt;
        angular.element($window).resize(function(event,doNotExecute) {

          if(doNotExecute){
            return false;
          }
          if ($window.resizeEvt) {
            $timeout.cancel($window.resizeEvt);
          }
          $window.resizeEvt = $timeout(function() {
            if ($window.innerWidth <= 1050) {
              angular.element('.js-module-nav').addClass('js-module-nav--toggle');
              angular.element('.js-module-content').addClass('js-module-content--toggle');
              angular.element($window).trigger('resize',true);
            }
            else {
              angular.element('.js-module-nav').removeClass('js-module-nav--toggle');
              angular.element('.js-module-content').removeClass('js-module-content--toggle');
              angular.element($window).trigger('resize',true);
            }
          }, 250);
        });
      //});
    }
  }
})();

'use strict'

angular.module('privacy')
.service('CustomElements', function($http, $q, $localStorage) {
  var customizations = {},
      vm = {};

  vm.promise = function() {
    return $http.get('customizations/'+ $localStorage['client'] +'.json').success(function(data) {
      if(data !== null) {
        if (angular.isDefined($localStorage['client'])) {
            if(angular.isDefined(data['icon'])) {
              var favicon = angular.element('link[rel="icon"]');
              var pathImage = "../../.." + data['icon'];
              favicon.attr('href', pathImage);
            }
            if(angular.isDefined(data['icon_png'])) {
              var icon = angular.element('link[rel="apple-touch-icon"]');
              var pathImage2 = "../../.." + data['icon_png'];
              icon.attr('type', 'image/png');
              icon.attr('href', pathImage2);
            }

        }
        customizations = data;
        return customizations;
      }
    });
  };

  vm.getData = function() {
    return $q.when(customizations);
  };

  //used for url
  vm.get = function get(key) {
    if (customizations.hasOwnProperty(key)) {
      return customizations[key];
    }
    return "";
  }

  return vm;
});

'use strict'

angular.module('privacy')
.directive('customstyle', function (CustomElements) {
	return {
		restrict: 'A',
    link: function (scope, element, attrs) {
      if (angular.isDefined(attrs.elements)) {
        CustomElements.getData().then(function(data) {
          if(data)  {
            var body = angular.element(document).find('body');
            body.css('background-color', data['main_background'] );
            var elements = angular.fromJson(attrs.elements);
            angular.forEach(elements, function(value, key){
              if (key === "border-radius" && data[value] !== '0') {
                if(data[value]) {
                  element.css(key, '25px');
                  element.css("border-style", "solid");
                  element.css("border-width", 'thin');
                }
              } else {
                element.css(key, data[value]);
              }
            });
          }
        });
      }
    }
  }
});

'use strict'

angular.module('privacy')
.directive('linkfaqstyle', function (CustomElements) {
  return {
    restrict: 'A',
    scope: {
      code : '=',
      name : '='
    },
    link: function (scope, element) {
      compare();

      scope.$watch('name', function() {
        compare();
      });

      function compare() {
        if(scope.name === scope.code){
          element.css('color', 'red');
        } else {
          element.css('color', 'white');
        }
        CustomElements.getData().then(function(data) {
          if(data) {
            if(scope.name === scope.code){
              element.css('color', data['link_color']);
            } else {
              element.css('color', data['sidebar_color']);
            }
          }
        });
      }
    }
   }
});

'use strict'

angular.module('privacy')
  .directive('linkstyle', function (CustomElements, $stateParams, $location) {
    return {
      restrict: 'A',
      scope: {
        elements: '='
      },
      link: function (scope, element) {
        compare();

        scope.$watch(function () {
          return $location.path();
        }, function () {
          compare();
        });

        function compare() {
          CustomElements.getData().then(function (data) {
            if (data) {
              if ($stateParams.hasOwnProperty('name')) {
                if (angular.equals($stateParams.name, scope.elements)) {
                  element.css('color', data['link_color']);
                } else {
                  element.css('color', data['sidebar_color']);
                }
              } else {
                if (scope.elements === true) {
                  element.css('color', data['link_color']);
                } else {
                  element.css('color', data['sidebar_color']);
                }
              }
            }
          });
        }
      }
    }
  });

'use strict'

angular.module('privacy')
.factory('SidePanel',function(
  $timeout, $rootScope, $document
) {
  var sides = {};
  var body = angular.element($document[0].body);

  var stateChange = $rootScope.$on('$stateChangeStart', closeAll);
  $rootScope.$on('$destroy', stateChange);

  function broadcastEvent(panel, isOpen) {
    $rootScope.$broadcast('sidepanel', {
      panel: panel,
      isOpen: isOpen
    });
  }

  function closeAll(panel) {
    for (var show in sides) {
      if (show !== panel) {
        sides[show] = false;
        broadcastEvent(show, false);
      }
    }

    closeBody();
  }

  function open(panel) {
    sides[panel] = true;
    broadcastEvent(panel, true);

    openBody();
  }

  function all() {
    return sides;
  }

  function close(panel) {
    sides[panel] = false;
    broadcastEvent(panel, false);

    closeBody();
  }

  function closeAllAndOpen(panel) {
      closeAll(panel);
      $timeout(function() {
        open(panel);
      }, 1);

      openBody();
  }

  function isOpen(panel) {
    return !!sides[panel];
  }

  function openBody() {
    body.removeClass('ng-pageslide-body-closed');
    body.addClass('ng-pageslide-body-open');
  }

  function closeBody() {
    body.removeClass('ng-pageslide-body-open');
    body.addClass('ng-pageslide-body-closed');
  }

  return {
    closeAll: closeAll,
    close: close,
    open: open,
    closeAllAndOpen: closeAllAndOpen,
    isOpen: isOpen,
    all: all
  };
});

'use strict'

angular.module('privacy')
.directive('openSide',function(
  SidePanel, Auth
) {
  return {
    restrict: "A",
    scope: {
      panel: '@openSide',
      disabled: '=sideDisabled',
      aclmap: '@aclMap'
    },
    controller: openSidePanel
  };
  function openSidePanel($element, $scope) {
    function bindClick() {
      $element.on('click', function(){
        if ($scope.disabled !== true) {
          SidePanel.closeAllAndOpen($scope.panel);
        }
      });
    }

    if (angular.isDefined($scope.aclmap) && $scope.aclmap !== '') {
      Auth.checkAccessList($scope.aclmap).then(function(result) {
        if (result) {
          bindClick();
        }

      });
    } else {
      bindClick();
    }
  }
})
.directive('sidePanel',function(
  SidePanel
) {
  return {
    restrict: "E",
    transclude: true,
    templateUrl: "app/components/sidepanel/sidepanel.template.html",
    scope: {
      panel: '@openBy',
      onOpen: '&',
      topVar: '@topVar'
    },
    controller: openSidePanelController
  };
  function openSidePanelController($scope) {
    $scope.$on('sidepanel', function(event, params) {
      if (params.panel === $scope.panel) {
        $scope.isOpen = params.isOpen;
        if ($scope.isOpen && $scope.onOpen) {
          if ($scope.onOpen) {
            $scope.onOpen();
          }
        }
      }
    });

    $scope.close = function() {
      SidePanel.closeAll();
    }
  }
});

'use strict'

angular.module('privacy')
.directive('socialentity', function (CustomElements) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      CustomElements.getData().then(function(data) {
        if(data) {
          if(data.hasOwnProperty('social_show')){
            if(data['social_show'] === '0') {
              element.css("display", "none");
            }
          }
        }
      });
    }
   }
});

'use strict'

angular.module('privacy')
.directive('resizeSidebar', function ($window) {
  return {
    restrict: 'A',
      link: function (scope) {
        var $bottomNav  = angular.element('.js-bottom-nav'),
            $sidebar    = angular.element('.js-outer-sidebar'),
            height      = 0;

        checkSize();

        angular.element($window).bind('resize', function(){
          height   = 0;
          checkSize();
          scope.$digest();
        });

        function checkSize() {
          if ($bottomNav.length > 0 && $sidebar.length > 0) {
            height = Math.floor($bottomNav.outerHeight(true)) + Math.floor($bottomNav.css('bottom').replace('px', ''));

            $sidebar.css('padding-bottom', height);
          } else {
           $sidebar.css('padding-bottom', '');
          }
        }
      }
   }
});

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith#Polyfill
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (!angular.isNumber(position) || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}

'use strict'

angular.module('privacy')
.directive('scroll', function ($window, $timeout) {
  return {
    restrict: 'A',
      link: function (scope) {
        var $submenu        = angular.element('.js-module-subnav'),
            $content        = angular.element('.js-module-subnav-content'),
            positionSubmenu = 0,
            positionContent = 0;

        function checkScroll() {
          var scrollTop = angular.element(window).scrollTop();
          if (scrollTop > positionSubmenu) {
            if (scrollTop > positionContent) {
              $submenu.addClass('absolute');
              $submenu.removeClass('fixed');
            } else {
              $submenu.addClass('fixed');
              $submenu.removeClass('absolute');
            }
          } else {
            $submenu.removeClass('fixed');
            $submenu.removeClass('absolute');
          }

          scope.$digest();
        }

        function setPosition() {
          $submenu.removeClass('fixed');
          $submenu.removeClass('absolute');

          positionSubmenu = $submenu.offset().top;
          positionContent = $content.offset().top + $content.outerHeight(true) - $submenu.outerHeight(true);

          checkScroll();
        }

        angular.element($window).bind('scroll', function(){
          checkScroll();
        });

        angular.element($window).bind('resize', function(){
          setPosition();
        });

        $timeout(function() {
          setPosition();
        }, 1000);
      }
   }
});

'use strict'

angular.module('privacy')
.directive('menu', function () {
  return {
    restrict: 'A',
      link: function (scope) {
        var $button  = angular.element('.js-menu-button'),
            $body = angular.element('body');

        $button.bind('click', function() {
          $button.toggleClass('active');
          $body.toggleClass('active-mobile-menu');
        });

        scope.$on('$locationChangeSuccess', function() {
          $button.removeClass('active');
          $body.removeClass('active-mobile-menu');
        })
      }
   }
});

'use strict'

angular.module('privacy')
.directive('mydatabutton', function (CustomElements) {
	return {
		restrict: 'A',
    link: function (scope, element) {
      CustomElements.getData().then(function(data) {
        if(data)  {
          var showButton = false;
          if (
            angular.isDefined(data['modify_dob']) && data['modify_dob'] === '1' ||
            angular.isDefined(data['modify_firstname']) && data['modify_firstname'] === '1' ||
            angular.isDefined(data['modify_gender']) && data['modify_gender'] === '1' ||
            angular.isDefined(data['modify_language']) && data['modify_language'] === '1' ||
            angular.isDefined(data['modify_name']) && data['modify_name'] === '1' ||
            angular.isDefined(data['modify_title']) && data['modify_title'] === '1'
          ) {
            showButton = true
          }

          if(!showButton) {
            element.css("display", "none");
          }
        }
      });
    }
  }
});

'use strict'

angular.module('privacy')
.directive('mydata', function (CustomElements) {
	return {
		restrict: 'A',
    link: function (scope, element, attrs) {
      if (angular.isDefined(attrs.data)) {
        var elements = angular.fromJson(attrs.data);
        CustomElements.getData().then(function(data) {
          if(data)  {
            angular.forEach(elements, function(value, key){
              if (data[key] === '1') {
                if (value === 'div') {
                  element.css("display", "none");
                }
              } else {
                if (value === 'input') {
                  element.css("display", "none");
                }
              }
            });
          }
        });
      }
    }
  }
});

'use strict'

angular.module('privacy')
.directive('matchHeight', function ($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element) {

      $timeout(function() {
        angular.element(element).find('.js-equal-height').matchHeight();
      }, 1100);
    }
  }
});

'use strict'

angular.module('privacy')
.service('url',function(
  CustomElements
) {

  function url(key) {
    if(key) {
      return  CustomElements.get(key);
    } else {
      return '';
    }
  }

  var vm = url;
  return vm;

});

'use strict'

angular.module('privacy')
.directive('linkurl', function (CustomElements, $localStorage, $rootScope) {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {

      function getUrl() {
        CustomElements.getData().then(function(data) {
          if(data) {
            if(data.hasOwnProperty(attr.urls)){
              element.attr("href", data[attr.urls][$localStorage['locale']]);
            }
          }
        });
      }

      getUrl();

      var watcher = $rootScope.$on('languageChanged', function() {
        getUrl();
      });

      $rootScope.$on('$destroy', function() {
        watcher();
      })
    }
   }
});

'use strict'

angular.module('privacy')
.directive('customimage', function (CustomElements) {
  return {
    restrict: 'A',
      link: function (scope, element, attrs) {
        if (angular.isDefined(attrs.elements)) {
          CustomElements.getData().then(function(data) {
            if(data) {
              if(data.hasOwnProperty(attrs.elements)) {
                if(data[attrs.elements] !== null) {
                  while(data[attrs.elements].charAt(0) === '/')
                  {
                    data[attrs.elements] = data[attrs.elements].substr(1);
                  }
                  var imagePath = location.pathname +  data[attrs.elements];
                  attrs.$set("src", imagePath);

                  element.bind('load', function() {
                    var $footer       = angular.element('.js-footer'),
                        $wrapper      = angular.element('.js-module-content'),
                        $bottomNav    = angular.element('.js-bottom-nav'),
                        $sidebar      = angular.element('.js-outer-sidebar'),
                        height        = 0,
                        heightSideBar = 0;

                    if ($footer.length > 0 && $wrapper.length > 0) {
                      height = $footer.outerHeight(true);
                      $wrapper.css('padding-bottom', height);
                    } else {
                      $wrapper.css('padding-bottom', '');
                    }

                    if ($bottomNav.length > 0 && $sidebar.length > 0) {
                      heightSideBar = $bottomNav.outerHeight(true);
                      $sidebar.css('padding-bottom', heightSideBar);
                    } else {
                     $sidebar.css('padding-bottom', '');
                    }

                  });
                } else {
                  element[0].classList.add("hidden");
                }
              }
            }
          });
        }
      }
   }
});

  angular
    .module('privacy')
    .filter('refList', refList);

    function refList() {
      return function (input, currentRef) {
        if (input.indexOf(currentRef) == -1) {
          input.push(currentRef);
        }
        return input;
      }
    }

  angular
    .module('privacy')
    .filter('padZeroes', padZeroesFilter);


  function padZeroesFilter() {
    return function (input, length) {
      var str = input + "";

      while (str.length < length)
        str = "0" + str;
      return str;
    }
  }

  angular
    .module('privacy')
    .filter('numberFormatted', numberFormattedFilter)
    .filter('euro', euroFilter);


  function euroFilter(numberFormattedFilter) {
    return function (input, hideZero, curSymbol, decPlaces, thouSep, decSep) {

      curSymbol = curSymbol || '€';
      hideZero = hideZero || false;

      var out = isNaN(input) || input === '' || input === null ? 0.0 : input;

      if (out === 0 && hideZero) return '-';
      var minus = input < 0;
      out = Math.abs(out);
      out = numberFormattedFilter(out, decPlaces, thouSep, decSep);

      if(minus){
        return "-" + curSymbol + out;
      }else{
        return curSymbol + out;
      }
    }
  }

  function numberFormattedFilter(numberFilter) {
  return function (input, decPlaces, thouSep, decSep) {

    decPlaces = decPlaces || 2;
    thouSep = thouSep || ".";
    decSep = decSep || ",";

    var out = isNaN(input) || input === '' || input === null ? 0.0 : input;

    var minus = input < 0;
    out = Math.abs(out);
    if (parseFloat(numberFilter(out,decPlaces)) == parseFloat(numberFilter(out, 4))) {
      out = numberFilter(out, decPlaces);
    } else {
      out = numberFilter(out, 4);
    }

    if(thouSep != ",") out = out.replace(/\,/g, "T");
    if(decSep != ".") out = out.replace(/\./g, "D");
    out = out.replace(/T/g, thouSep);
    out = out.replace(/D/g, decSep);

    if(minus){
      return "-" + out;
    }else{
      return out;
    }
  }

  }

'use strict'

angular.module('privacy')
.directive('resizeFooter', function ($window, $timeout) {
  return {
    restrict: 'A',
      link: function (scope) {
        var $footer  = angular.element('.js-footer'),
            $wrapper = angular.element('.js-module-content'),
            height   = 0;


        $timeout(function() {
          checkSize();
        },250);

        angular.element($window).bind('resize', function(){
          height = 0;
          checkSize();
          scope.$digest();
        });

        function checkSize() {
          if ($footer.length > 0 && $wrapper.length > 0) {
            height = $footer.outerHeight(true);
            $wrapper.css('padding-bottom', height);
          } else {
           $wrapper.css('padding-bottom', '');
          }
        }
      }
   }
});

'use strict';

var loadedScripts = [];

angular.module('privacy')
.directive('dashboard',function(
  $document, $window
) {
  return {
    restrict: 'A',
    scope: {
      code: '=dashboard',
      firstime: '=firstime'
    },
    replace : true,
    link: function($scope, element) {
      var $body = angular.element($document[0].body);
      var inlineScripts = [];

      function loadExternalScript(scriptTag) {
        if (loadedScripts.indexOf(scriptTag.src) === -1) {
          $.getScript(scriptTag.src, function() {
            loadInlineScripts();
          });
          loadedScripts.push(scriptTag.src);
        } else {
          loadInlineScripts();
        }
      }

      function loadInlineScripts() {
        for (var i = 0; i < inlineScripts.length; i++) {
          $body.append(inlineScripts[i]);
        }
        inlineScripts = [];
      }

      function loadDashboard() {
        if (!$scope.code) {
          return;
        }

        cleanUp(true);

        var elements = angular.element($scope.code);

        if (elements.length > 0) {
          var externalScript = false;
          for (var index = 0; index < elements.length; index++) {
            var el = elements[index];

            if (!$scope.firstime) {
              el.innerHTML = el.innerHTML.replace('google.charts.load("current", {packages:[\'corechart\']});','');
            }

            if (el.tagName === 'SCRIPT' ) {
                if (el.hasAttribute('src')) {
                  externalScript = el;
                } else {
                  inlineScripts.push(el);
                }
            } else {
              element.empty();
              element.append(el);
            }
          }
          loadExternalScript(externalScript);
        }
      }

      var unbindWatch = $scope.$watch('code', loadDashboard);

      function cleanUp(empty) {

        if (empty) {
          element.empty();
        } else {
          unbindWatch();
          element.remove();
        }
        loadedScripts = [];

        angular.element('.block-ui-container').nextAll('script').remove();

        if (angular.isDefined($window.google) && angular.isDefined($window.google.charts)) {
          $window.google.charts = undefined;
        }
      }

      $scope.$on('$destroy', cleanUp);
    },
    controllerAs: 'vm'
  };
})

'use strict'

angular.module('privacy')
.directive('legendhide', function (CustomElements) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      CustomElements.getData().then(function(data) {
        if(data) {
          if(data.hasOwnProperty('legend_permission_show')){
            if(data['legend_permission_show'] === '0') {
              element.css("display", "none");
            }
          }
        }
      });
    }
   }
});


'use strict'

angular.module('privacy')
.directive('ctahide', function (CustomElements, $localStorage) {
  return {
    restrict: 'A',
    scope: {
      elements: '='
    },
    link: function (scope, element, attr) {
      CustomElements.getData().then(function(data) {
        if(data) {
          if(data.hasOwnProperty('cta_button_link') && data.hasOwnProperty('cta_show') ){
            if(data['cta_show'] !== '0') {
              if(data['cta_button_link'][$localStorage['locale']] === null && attr.ctatype === "link") {
                element.css("display", "none");
              } else if(data['cta_button_link'][$localStorage['locale']] !== null && attr.ctatype === "default") {
                element.css("display", "none");
              }
            } else {
              element.css("display", "none");
            }
          }
        }
      });
    }
   }
});

'use strict'

angular.module('privacy')
.service('ConfirmationService',function(
  $uibModal, t
) {

  var vm = {};

  vm.confirmRemove = function(question, info) {
    return $uibModal.open({
      templateUrl: 'app/components/confirmation/confirm-remove.html',
      controllerAs: 'confirmation',
      controller: function() {
        var vm = this;
        vm.question = question;

        if (angular.isDefined(info) && info) {
          vm.info = info;
        } else {
          vm.info = t('confirmation_confirm_remove_info');
        }
      }
    }).result;
  };

  return vm;

});

/*eslint-disable */
var SOAPClient = window.SOAPClient || {};
// /*****************************************************************************\

//  Javascript "SOAP Client" library

//  @version: 2.4 - 2007.12.21
//  @author: Matteo Casati - http://www.guru4.net/

// \*****************************************************************************/

// function SOAPClientParameters()
// {
//   var _pl = new Array();
//   this.add = function(name, value)
//   {
//     _pl[name] = value;
//     return this;
//   }
//   this.toXml = function()
//   {
//     var xml = "";
//     for(var p in _pl)
//     {
//       switch(typeof(_pl[p]))
//       {
//                 case "string":
//                 case "number":
//                 case "boolean":
//                 case "object":
//                     xml += "<" + p + ">" + SOAPClientParameters._serialize(_pl[p]) + "</" + p + ">";
//                     break;
//                 default:
//                     break;
//             }
//     }
//     return xml;
//   }
// }
SOAPClientParameters._serialize = function(o)
{
    var s = "";
    switch(typeof(o))
    {
        case "string":
            s += o.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); break;
        case "number":
        case "boolean":
            s += o.toString(); break;
        case "object":
            // moment
            if(o == null) {
            }
            else if(o._isAMomentObject) {
              s += o.toISOString();
            }
            // Date
            else if(o.constructor.toString().indexOf("function Date()") > -1)
            {
                var year = o.getFullYear().toString();
                var month = (o.getMonth() + 1).toString(); month = (month.length == 1) ? "0" + month : month;
                var date = o.getDate().toString(); date = (date.length == 1) ? "0" + date : date;
                var hours = o.getHours().toString(); hours = (hours.length == 1) ? "0" + hours : hours;
                var minutes = o.getMinutes().toString(); minutes = (minutes.length == 1) ? "0" + minutes : minutes;
                var seconds = o.getSeconds().toString(); seconds = (seconds.length == 1) ? "0" + seconds : seconds;
                var milliseconds = o.getMilliseconds().toString();
                var tzminutes = Math.abs(o.getTimezoneOffset());
                var tzhours = 0;
                while(tzminutes >= 60)
                {
                    tzhours++;
                    tzminutes -= 60;
                }
                tzminutes = (tzminutes.toString().length == 1) ? "0" + tzminutes.toString() : tzminutes.toString();
                tzhours = (tzhours.toString().length == 1) ? "0" + tzhours.toString() : tzhours.toString();
                var timezone = ((o.getTimezoneOffset() < 0) ? "+" : "-") + tzhours + ":" + tzminutes;
                s += year + "-" + month + "-" + date + "T" + hours + ":" + minutes + ":" + seconds + "." + milliseconds + timezone;
            }
            // Array
            else if(o.constructor.toString().indexOf("function Array()") > -1)
            {
                for(var p in o)
                {
                    if(!isNaN(p))   // linear array
                    {
                        (/function\s+(\w*)\s*\(/ig).exec(o[p].constructor.toString());
                        var type = RegExp.$1;
                        switch(type)
                        {
                            case "":
                                type = typeof(o[p]);
                            case "String":
                                type = "string"; break;
                            case "Number":
                                type = "int"; break;
                            case "Boolean":
                                type = "bool"; break;
                            case "Date":
                                type = "DateTime"; break;
                            case "Object":
                                if(o[p].hasOwnProperty("$tagName")) {
                                  type = o[p].$tagName;

                                  if (o[p].hasOwnProperty('xmlValue') && Object.keys(o[p]).length === 2) {
                                    o[p] = o[p].xmlValue;
                                  }
                                }
                                break;
                        }
                        s += "<" + type + ">" + SOAPClientParameters._serialize(o[p]) + "</" + type + ">"
                    }
                    else    // associative array
                        s += "<" + p + ">" + SOAPClientParameters._serialize(o[p]) + "</" + p + ">"
                }
            }
            // Object or custom function
            else {
                for(var p in o) {
                  // don't serialize junk
                  if(/^[a-zA-Z_]/.test(p)) {
                    // xsi:nil for null/undefined fields
                    if(angular.isUndefined(o[p]) || o[p] === null) {
                      s += "<" + p + " xsi:nil=\"true\" />";
                    }
                    else {
                      s += "<" + p + ">" + SOAPClientParameters._serialize(o[p]) + "</" + p + ">";
                    }
                  }
                }
              }
            break;
        default:
            break; // throw new Error(500, "SOAPClientParameters: type '" + typeof(o) + "' is not supported");
    }
    return s;
}

// function SOAPClient() {}

// SOAPClient.username = null;
// SOAPClient.password = null;

// SOAPClient.invoke = function(url, method, parameters, async, callback)
// {
//   if(async)
//     SOAPClient._loadWsdl(url, method, parameters, async, callback);
//   else
//     return SOAPClient._loadWsdl(url, method, parameters, async, callback);
// }

// // private: wsdl cache
// SOAPClient_cacheWsdl = new Array();

// // private: invoke async
// SOAPClient._loadWsdl = function(url, method, parameters, async, callback)
// {
//   // load from cache?
//   var wsdl = SOAPClient_cacheWsdl[url];
//   if(wsdl + "" != "" && wsdl + "" != "undefined")
//     return SOAPClient._sendSoapRequest(url, method, parameters, async, callback, wsdl);
//   // get wsdl
//   var xmlHttp = SOAPClient._getXmlHttp();
//   xmlHttp.open("GET", url + "?wsdl", async);
//   if(async)
//   {
//     xmlHttp.onreadystatechange = function()
//     {
//       if(xmlHttp.readyState == 4)
//         SOAPClient._onLoadWsdl(url, method, parameters, async, callback, xmlHttp);
//     }
//   }
//   xmlHttp.send(null);
//   if (!async)
//     return SOAPClient._onLoadWsdl(url, method, parameters, async, callback, xmlHttp);
// }
// SOAPClient._onLoadWsdl = function(url, method, parameters, async, callback, req)
// {
//   var wsdl = req.responseXML;
//   SOAPClient_cacheWsdl[url] = wsdl; // save a copy in cache
//   return SOAPClient._sendSoapRequest(url, method, parameters, async, callback, wsdl);
// }
// SOAPClient._sendSoapRequest = function(url, method, parameters, async, callback, wsdl)
// {
//   // get namespace
//   var ns = (wsdl.documentElement.attributes["targetNamespace"] + "" == "undefined") ? wsdl.documentElement.attributes.getNamedItem("targetNamespace").nodeValue : wsdl.documentElement.attributes["targetNamespace"].value;
//   // build SOAP request
//   var sr =
//         "<?xml version=\"1.0\" encoding=\"utf-8\"?>" +
//         "<soap:Envelope " +
//         "xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" " +
//         "xmlns:xsd=\"http://www.w3.org/2001/XMLSchema\" " +
//         "xmlns:soap=\"http://schemas.xmlsoap.org/soap/envelope/\">" +
//         "<soap:Body>" +
//         "<" + method + " xmlns=\"" + ns + "\">" +
//         parameters.toXml() +
//         "</" + method + "></soap:Body></soap:Envelope>";
//   // send request
//   var xmlHttp = SOAPClient._getXmlHttp();
//   if (SOAPClient.userName && SOAPClient.password){
//     xmlHttp.open("POST", url, async, SOAPClient.userName, SOAPClient.password);
//     // Some WS implementations (i.e. BEA WebLogic Server 10.0 JAX-WS) don't support Challenge/Response HTTP BASIC, so we send authorization headers in the first request
//     xmlHttp.setRequestHeader("Authorization", "Basic " + SOAPClient._toBase64(SOAPClient.userName + ":" + SOAPClient.password));
//   }
//   else
//     xmlHttp.open("POST", url, async);
//   var soapaction = ((ns.lastIndexOf("/") != ns.length - 1) ? ns + "/" : ns) + method;
//   xmlHttp.setRequestHeader("SOAPAction", soapaction);
//   xmlHttp.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
//   if(async)
//   {
//     xmlHttp.onreadystatechange = function()
//     {
//       if(xmlHttp.readyState == 4)
//         SOAPClient._onSendSoapRequest(method, async, callback, wsdl, xmlHttp);
//     }
//   }
//   xmlHttp.send(sr);
//   if (!async)
//     return SOAPClient._onSendSoapRequest(method, async, callback, wsdl, xmlHttp);
// }

// SOAPClient._onSendSoapRequest = function(method, async, callback, wsdl, req)
// {
//   var o = null;
//   var nd = SOAPClient._getElementsByTagName(req.responseXML, method + "Result");
//   if(nd.length == 0)
//     nd = SOAPClient._getElementsByTagName(req.responseXML, "return"); // PHP web Service?
//   if(nd.length == 0)
//   {
//     if(req.responseXML.getElementsByTagName("faultcode").length > 0)
//     {
//         if(async || callback)
//             o = new Error(500, req.responseXML.getElementsByTagName("faultstring")[0].childNodes[0].nodeValue);
//       else
//           throw new Error(500, req.responseXML.getElementsByTagName("faultstring")[0].childNodes[0].nodeValue);
//     }
//   }
//   else
//     o = SOAPClient._soapresult2object(nd[0], wsdl);
//   if(callback)
//     callback(o, req.responseXML);
//   if(!async)
//     return o;
// }
// SOAPClient._soapresult2object = function(node, wsdl)
// {
//     var wsdlTypes = SOAPClient._getTypesFromWsdl(wsdl);
//     return SOAPClient._node2object(node, wsdlTypes);
// }
SOAPClient._nodeAttributes = function(node)
{
  if(node.attributes && node.attributes.length > 0) {
    var obj = {};
    for(var i = 0; i < node.attributes.length; i++) {
      var attr = node.attributes.item(i);
      obj['@'+attr.name] = attr.value;
    }
    // special case: tag with xsi:nil
    if(node.attributes.length === 1 && obj['@xsi:nil'] === 'true') {
      return null;
    }
    return obj;
  }
  else {
    return null;
  }
};
SOAPClient._node2object = function(node, wsdlTypes)
{
  var attributes = undefined;
  // null node
  if(node == null) {
    return null;
  }
  // text node
  if(node.nodeType == 3 || node.nodeType == 4) {
    return SOAPClient._extractValue(node, wsdlTypes);
  }
  // leaf node
  if (node.childNodes.length == 1 && (node.childNodes[0].nodeType == 3 || node.childNodes[0].nodeType == 4)) {
    var value = SOAPClient._node2object(node.childNodes[0], wsdlTypes);
    attributes = SOAPClient._nodeAttributes(node);
    if(attributes) {
      return angular.extend(new Object(value), attributes);
    }
    return value;
  }
  var isarray = SOAPClient._getTypeFromWsdl(node.nodeName, wsdlTypes).toLowerCase().indexOf("arrayof") != -1;
  // object node
  if(!isarray)
  {
    var obj = null;
    if(node.hasChildNodes())
      obj = new Object();

    for(var i = 0; i < node.childNodes.length; i++)
    {
      var p = SOAPClient._node2object(node.childNodes[i], wsdlTypes);
      var cname = node.childNodes[i].nodeName;
      if (obj[cname]) {
        if (obj[cname] instanceof Array) {
          obj[cname].push(p);
        }
        else {
          obj[cname] = new Array(obj[cname]);
          obj[cname].push(p);
        }
      }
      else {
        obj[cname] = p;
      }
    }
    attributes = SOAPClient._nodeAttributes(node);
    if(attributes) {
      if(obj === null) {
        return attributes;
      }
      else {
        angular.extend(obj, attributes);
      }
    }
    return obj;
  }
  // list node
  else
  {
    // create node ref
    var l = new Array();
    for(var j = 0; j < node.childNodes.length; j++)
      l[l.length] = SOAPClient._node2object(node.childNodes[j], wsdlTypes);
    return l;
  }
  return null;
}
SOAPClient._extractValue = function(node, wsdlTypes)
{
  var value = node.nodeValue;
  switch(SOAPClient._getTypeFromWsdl(node.parentNode.nodeName, wsdlTypes).toLowerCase())
  {
    default:
    case "s:string":
      return (value != null) ? value + "" : "";
    case "s:boolean":
      //-- API returns invalid WSDL type for 'creation' field
      if(node.parentNode.nodeName === 'creation') {
        var dt = moment(value);
        if(dt.isValid()) {
          return dt;
        }
      }

      //-- end of fix
      return (value + "" == "true" || value + "" == "1");
    case "s:int":
    case "s:long":
      return (value != null) ? parseInt(value + "", 10) : 0;
    case "s:double":
      return (value != null) ? parseFloat(value + "") : 0;
    case "s:datetime":
      if(value === null) {
        return null;
      }
      else {
        return moment(value);
      }
      //--OLD
      // if(value == null)
      //   return null;
      // else
      // {
      //   value = value + "";
      //   value = value.substring(0, (value.lastIndexOf(".") == -1 ? value.length : value.lastIndexOf(".")));
      //   value = value.replace(/T/gi," ");
      //   value = value.replace(/-/gi,"/");
      //   var d = new Date();
      //   d.setTime(Date.parse(value));
      //   return d;
      // }
  }
}
// SOAPClient._getTypesFromWsdl = function(wsdl)
// {
//   var wsdlTypes = new Array();
//   // IE
//   var ell = wsdl.getElementsByTagName("s:element");
//   var useNamedItem = true;
//   // MOZ
//   if(ell.length == 0)
//   {
//     ell = wsdl.getElementsByTagName("element");
//     useNamedItem = false;
//   }
//   for(var i = 0; i < ell.length; i++)
//   {
//     if(useNamedItem)
//     {
//       if(ell[i].attributes.getNamedItem("name") != null && ell[i].attributes.getNamedItem("type") != null)
//         wsdlTypes[ell[i].attributes.getNamedItem("name").nodeValue] = ell[i].attributes.getNamedItem("type").nodeValue;
//     }
//     else
//     {
//       if(ell[i].attributes["name"] != null && ell[i].attributes["type"] != null)
//         wsdlTypes[ell[i].attributes["name"].value] = ell[i].attributes["type"].value;
//     }
//   }
//   return wsdlTypes;
// }
// SOAPClient._getTypeFromWsdl = function(elementname, wsdlTypes)
// {
//     var type = wsdlTypes[elementname] + "";
//     return (type == "undefined") ? "" : type;
// }
// // private: utils
// SOAPClient._getElementsByTagName = function(document, tagName)
// {
//   try
//   {
//     // trying to get node omitting any namespaces (latest versions of MSXML.XMLDocument)
//     return document.selectNodes(".//*[local-name()=\""+ tagName +"\"]");
//   }
//   catch (ex) {}
//   // old XML parser support
//   return document.getElementsByTagName(tagName);
// }
// // private: xmlhttp factory
// SOAPClient._getXmlHttp = function()
// {
//   try
//   {
//     if(window.XMLHttpRequest)
//     {
//       var req = new XMLHttpRequest();
//       // some versions of Moz do not support the readyState property and the onreadystate event so we patch it!
//       if(req.readyState == null)
//       {
//         req.readyState = 1;
//         req.addEventListener("load",
//                   function()
//                   {
//                     req.readyState = 4;
//                     if(typeof req.onreadystatechange == "function")
//                       req.onreadystatechange();
//                   },
//                   false);
//       }
//       return req;
//     }
//     if(window.ActiveXObject)
//       return new ActiveXObject(SOAPClient._getXmlHttpProgID());
//   }
//   catch (ex) {}
//   throw new Error("Your browser does not support XmlHttp objects");
// }
// SOAPClient._getXmlHttpProgID = function()
// {
//   if(SOAPClient._getXmlHttpProgID.progid)
//     return SOAPClient._getXmlHttpProgID.progid;
//   var progids = ["Msxml2.XMLHTTP.5.0", "Msxml2.XMLHTTP.4.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"];
//   var o;
//   for(var i = 0; i < progids.length; i++)
//   {
//     try
//     {
//       o = new ActiveXObject(progids[i]);
//       return SOAPClient._getXmlHttpProgID.progid = progids[i];
//     }
//     catch (ex) {};
//   }
//   throw new Error("Could not find an installed XML parser");
// }

// SOAPClient._toBase64 = function(input)
// {
//   var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//   var output = "";
//   var chr1, chr2, chr3;
//   var enc1, enc2, enc3, enc4;
//   var i = 0;

//   do {
//     chr1 = input.charCodeAt(i++);
//     chr2 = input.charCodeAt(i++);
//     chr3 = input.charCodeAt(i++);

//     enc1 = chr1 >> 2;
//     enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
//     enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
//     enc4 = chr3 & 63;

//     if (isNaN(chr2)) {
//       enc3 = enc4 = 64;
//     } else if (isNaN(chr3)) {
//       enc4 = 64;
//     }

//     output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) +
//     keyStr.charAt(enc3) + keyStr.charAt(enc4);
//   } while (i < input.length);

//   return output;
// }
/*eslint-enable */

'use strict'

angular.module('privacy')
  .service('Relen', function (
    API
  ) {

    var vm = {};

    vm.getContact = function getContact() {
      return API.call('PaaSGetContact', {}, true).then(function (result) {
        return result.data;
      });
    };

    vm.updateIndividual = function updateIndividual(data) {
      return API.call('PaaSUpdateIndividual', {
        data: data
      }, {}, true);
    };

    vm.addTouchpoint = function addTouchpoint(data) {
      return API.call('PaaSAddTouchPoint', {
        data: data
      }, {}, true);
    };

    vm.addPostTouchpoint = function addPostTouchpoint(data) {
      return API.call('PaaSAddPOSTTouchPoint', {
        data: data
      }, {}, true);
    };

    vm.updateTouchpoint = function addTouchpoint(data) {
      return API.call('PaaSUpdateTouchPoint', {
        data: data
      }, {}, true);
    };

    vm.updatePostTouchpoint = function addPostTouchpoint(data) {
      return API.call('PaaSUpdatePOSTTouchPoint', {
        data: data
      }, {}, true);
    };

    vm.deleteTouchpoint = function deleteTouchpoint(reltpID) {
      return API.call('PaaSDeleteTouchPoint', {
        data: {
          reltpID: reltpID
        }
      }, {}, true);
    };

    vm.updatePermission = function updatePermission(data) {
      return API.call('PaaSUpdatePermission', {
        data: data
      }, {}, true);
    }

    vm.permissionTabOpened = function permissionsTabOpened() {
      return API.call('PaaSPermissionsTabOpened', {}, {}, true)
    }

    vm.faqs = function faqs() {
      return API.call('PaaSFAQs', {}, {}, true)
    }

    vm.faq = function faq(faqId) {
      return API.call('PaaSFAQ', {
        PaaSFAQInput: {
          faqID: faqId
        }
      }, {}, true);
    }

    vm.getAllPossiblePermissions = function (cmsName) {
      return API.call('PaaSGetAllPossiblePermissions', {
        cmsName: cmsName
      }, {}, true).then(function (result) {
        return result.data;
      });
    }

    vm.getURL = function getURL(data) {
      return API.call('PaaSGetURL_t', {
        data: data
      }, {}, true).then(function (result) {
        return result.data;
      }).catch(function (error) {
        return error;
      });
    }

    vm.getClient = function getClient() {
      return API.call('PaaSGetClient_t', {
        data: {
          application: 'Website'
        }
      }, {}, true).then(function (result) {
        return result.data;
      });
    }

    vm.paaSGetTab = function paaSGetTab(name) {
      return API.call('PaaSGetTab_t', {
        data: {
          tabName: name
        }
      }, {}, true);
    };


    return vm;

  });

'use strict'

angular.module('privacy')
.service('Ref',function(
  API
) {

  var vm = {};

  function getData(field) {
    return function(resp) {
      return resp.data[field];
    }

  }

  function getObjects(valueField, attributes, checkValueField) {

    return function(objects) {
      return objects.map(function(object) {
        var obj = {};
        obj[valueField] = object.valueOf();
        if (checkValueField && typeof obj[valueField] + "" != "string") {
          obj[valueField] = "";
        }
        attributes.forEach(function(attribute) {
          obj[attribute] = object['@'+attribute];
        });
        return obj;
      });
    };
  }

  function getObjectsFromArray(attributes) {
    return function(objects) {
      return objects.map(function(object) {
        var obj = {};
        attributes.forEach(function(attribute) {
          obj[attribute] = object['@'+attribute];
        });
        return obj;
      });
    };
  }


  vm.languages = function() {
    return API.call('PaaSRefLanguages')
    .then(getData('languageCodes'))
    .then(getObjects('languageCode', ['description', 'inGUIDropDown']))
    .then(function(data){
      var languages = [];
      for (var i = 0;i < data.length;i++) {
        if (data[i].inGUIDropDown == 'true') {
          languages.push(data[i]);
        }
      }
      return languages;
    });
  };

  vm.countries = function() {
    return API.call('PaaSRefCountries')
    .then(getData('countryCodes'))
    .then(getObjects('countryCode', ['description']));
  };

  vm.genders = function() {
    return API.call('PaaSRefGenders')
    .then(getData('genderCodes'))
    .then(getObjects('genderCode', ['description', 'inGUIDropDown']));
  };

  vm.titles = function() {
    return API.call('PaaSRefTitleCodes')
    .then(getData('titleCodes'))
    .then(getObjects('titleCode', [
      'genderCode',
      'languageCode',
      'salutation'
    ]));
  };

  vm.reltpCombinations = function() {
    return API.call('PaaSRefReltpCombinations')
    .then(getData('reltpCombinations'))
    .then(getObjectsFromArray(['tpCode', 'tpCodeDescription', 'tpSubCode', 'tpSubCodeDescription']));
  };

  vm.reltpCodes = function() {
    return API.call('PaaSRefReltpCodes')
    .then(getData('reltpCodes'))
    .then(getObjects('reltpCode', ['description']));
  };

  vm.inOutCodes= function() {
    return API.call('PaaSRefInOutCodes')
    .then(getData('inOutCodes'))
    .then(getObjects('inOutCode', ['description']));
  };

  return vm;
});

'use strict'

angular.module('privacy')
.constant('LS_AUTH_USER','auth.user')
.constant('SESSION_TIMEOUT',2*60*60*1000)
.service('Auth',function(
  LS_AUTH_USER, SESSION_TIMEOUT,
  $q, $log, $timeout, $sessionStorage, moment, $location,
  API, Util, $filter, $localStorage, t, $window, toastr
) {

  var vm = {};

  vm.user = undefined;

  function getExpiration() {
    var expiration = moment();
    expiration.add(SESSION_TIMEOUT);
    return expiration;
  }

  var sessionTimeoutNotifier = Util.createNotifier(1);
  vm.onSessionTimeout = function(fn) {
    sessionTimeoutNotifier.listen(fn);
  };
  var sessionTimeout = undefined;
  API.onAPICall(function(method) {
    if(sessionTimeout) {
      $timeout.cancel(sessionTimeout);
    }
    // notify all listeners after 2 hours
    sessionTimeout = $timeout(function() {
      sessionTimeoutNotifier.notify();
    },SESSION_TIMEOUT, false);
    // update the expiration date and store in sessionStorage
    if (method !== 'PaaSDoLoginWithToken_t') {
      if (!vm.user) {
        vm.user = {};
      }
      vm.user.validUntil = getExpiration();
      $sessionStorage[LS_AUTH_USER] = vm.user;
    }
  });

  function setLogin(data) {
    API.setToken(data.token);
    API.setPaaSToken(data.PaaSToken);

    if (angular.isDefined(data.AuthenticationString)) {
      API.setAuthenticationString(data.AuthenticationString);
    }

    t.setLanguage(data.languageCode);
    $localStorage['logoutURL'] = data.logoutURL;

    setAcl(data.ACL["AC"]);

    data.validUntil = getExpiration();
    vm.user = data;

    $sessionStorage['loged_in'] = true;
    $sessionStorage[LS_AUTH_USER] = vm.user;

    return vm.user;
  }

  var acl = [];

  vm.getTokenInfo = function(token) {
    return API.tokenInfo(token).then(function(data) {
      t.setLanguage(data.languageCode);
      $localStorage['token'] = token;
      $localStorage['client'] = data.Client;
      toastr.success(data.AuthorizationMessage);
      return data.NeedsAutorizationCode;
    });
  }

  vm.doLogin = function(token) {
    return API.login(token).then(function(data) {
      return setLogin(data);
    });
  };

  vm.doLoginWithCode = function(token, code) {
    return API.loginWithCode(token, code).then(function(data) {
      return setLogin(data);
    });
  }

  vm.reLogin = function() {
    return API.login(API.getPaaSToken()).then(function(data) {
      return setLogin(data);
    });
  };

  vm.doLogout = function() {
    if(sessionTimeout) {
      $timeout.cancel(sessionTimeout);
      sessionTimeout = undefined;
    }
    API.setToken(undefined);
    API.setPaaSToken(undefined);
    //$localStorage.$reset();
    $sessionStorage.$reset();
    vm.user = undefined;
    acl = [];
  };

  vm.doLoginFromCache = function() {
    // fetch the user from cache
    var user = $sessionStorage[LS_AUTH_USER];
    // check if the user has expired
    if(
      user && user.validUntil &&
      moment.tz(user.validUntil, 'Europe/London')
        .diff(moment.tz('Europe/London')) > 0
    ) {
      $log.debug('login from cache');
      setLogin(user);
      return user;
    }
    return false;
  };

  function setAcl(list) {
    acl = list;
  }

  vm.checkAccessList = function(key) {
    return $filter('filter')(acl, {
      '@path': key,
      '@hasAccess': 'true'
    }, true).length;
  };

  return vm;

});

'use strict'

angular.module('privacy')
.service('App',function(
  $filter, $q, $log, $localStorage, $timeout, Ref, Util, t, Relen, $rootScope
) {

  var vm = {};

  vm.contact = {};
  /**
   * An resources reference object provides following interface:
   * {
   *    get(id) => retrieve the resource given an identifier
   *    load() => load the values for the resource
   *    map => mapped resource data
   * }
   *
   * @param group:string Ref[group] fetches the resources
   * @param refFn:function()=>Promise will return the collection of resources
   * @param mapper:function(collection)=>map mapping of ID => resource;
   * @param getter:function(map,id)=>resource retrieves resource given an ID
   */
  function refResource(group, refFn, mapper, getter) {

    var ref = {
      get: function(id) {
        if(!ref.map) {
          throw new Error(group + ' resource is not initialized yet');
        }
        return getter(ref.map, id);
      },
      options: function(id) {
        if(!ref.map) {
          throw new Error(group + ' resource is not initialized yet');
        }

        var selectable = $filter('filter')($filter('toArray')(ref.map), {inGUIDropDown: true});
        var thisRef = getter(ref.map, id);

        if (angular.isDefined(thisRef) && angular.isDefined(thisRef.inGUIDropDown) && (!thisRef.inGUIDropDown || thisRef.inGUIDropDown === 'false')) {
          selectable.push(thisRef);
        }

        return selectable;
      }
    };

    ref.load = function() {
      var cacheKey = 'cache.app.' + group;
      var d = $q.defer();
      // load from cache
      var cached = $localStorage[cacheKey];
      if(cached) {
        // make it available
        ref.map = mapper(cached);
        // and resolve the promise
        d.resolve(ref.map);
      }
      // always fetch the resource from the server
      // but do so with a minimal delay
      $timeout(function() {
        refFn().then(function(collection) {
          if(angular.isUndefined(collection)) {
            throw new Error('refFn('+group+') => undefined');
          }
          // update the cached version
          $localStorage[cacheKey] = collection;
          ref.map = mapper(collection);
          if(cached) {
            // notify the update if already resolved
            d.notify(ref.map);
          }
          else {
            // resolve the promise
            d.resolve(ref.map);
          }
        },function(err) {
          if(cached) {
            $log.error(group + ' cache resolved, server failed');
          }
          else {
            d.reject(err);
          }
        });
      });
      return d.promise;
    };
    // return the interface
    return ref;
  }

  function refSimpleResource(group, item) {
    var mapper = function(collection) {
      return Util.mapArray(collection, item);
    };
    var getter = function(map, id) {
      return map[id];
    };
    return refResource(group, Ref[group], mapper, getter);
  }

  vm.genders = refSimpleResource('genders', 'genderCode');
  vm.countries = refSimpleResource('countries', 'countryCode');
  vm.languages = refSimpleResource('languages', 'languageCode');
  vm.reltpCodes = refSimpleResource('reltpCodes', 'reltpCode');
  vm.inOutCodes = refSimpleResource('inOutCodes', 'inOutCode');

  function combinationsMapper(combinations) {
    var map1 = {};
    combinations.forEach(function(combination) {
      if (angular.isUndefined(map1[combination.tpCode])) {
        map1[combination.tpCode] = new Array();
      }
      map1[combination.tpCode].push(combination);
    });
    return map1;
  }
  function defaultGetter(map, id) {
    return map[id];
  }

  vm.reltpCombinations = refResource('reltpCombinations', Ref.reltpCombinations, combinationsMapper, defaultGetter);


  function titleGetter(map, individual) {
    return map[individual.titleCode]
      [individual.genderCode]
      [individual.languageCode];
  }

  function titlesMapper(titles) {
    var map1 = {};
    titles.forEach(function(title) {
      if(!map1.hasOwnProperty(title.titleCode)) {
        map1[title.titleCode] = {};
      }
      var map2 = map1[title.titleCode];
      if(!map2.hasOwnProperty(title.genderCode)) {
        map2[title.genderCode] = {};
      }
      var map3 = map2[title.genderCode];
      map3[title.languageCode] = title;
    });
    return map1;
  }

  vm.titles = refResource('titles', Ref.titles, titlesMapper, titleGetter);

  var initialized = false;
  vm.deinitialize = function() {
    initialized = false;
  }

  vm.refreshContact = function refreshContact() {
    return Relen.getContact().then(function(data) {
      vm.contact = data;
    });
  };

  vm.initialize = function() {
    // only initialize once
    if (initialized === true) {
      return $q.resolve(vm);
    } else {
      // unset the initialized in case it was already
      initialized = false;
    }

    var refLoader = [
      vm.genders,
      vm.titles,
      vm.countries,
      vm.languages,
      vm.reltpCodes,
      vm.reltpCombinations,
      vm.inOutCodes
    ];

    // wait for all ref loaders to complete
    return $q.all(refLoader.map(function(ref) {
      return ref.load();
    })).then(function() {
      return vm.refreshContact();
    }).then(function() {

      // mark the app as loaded
      initialized = true;

      // resolve the App interface
      return vm;
    });
  };

  var watcher = $rootScope.$on('languageChanged', function() {
    vm.deinitialize();
    vm.initialize();
  });

  $rootScope.$on('$destroy', function() {
    watcher();
  })

  return vm;
});

'use strict'

angular.module('privacy')
  .constant('SIGNAL_API_CALL_STARTED', 'SIGNAL_API_CALL_STARTED')
  .constant('SIGNAL_API_CALL_ENDED', 'SIGNAL_API_CALL_ENDED')
  .service('API', function (
    $soap, $log, $q, $filter, $rootScope,
    Util, toastr,
    SIGNAL_API_CALL_STARTED, SIGNAL_API_CALL_ENDED, $location
  ) {

    var baseUrl = 'https://api.mymip.be/API_2_latest/MipSoapAPI.asmx';

    if ($location.port() > 1000) {
      // If we use a port, it's local
      baseUrl = 'api/MipSoapAPI.asmx';
    } else if ($location.host() === 'devpaas.mymip.be' || $location.host() === 'developmentstratics.mypersonaldata.info' || $location.host() === 'development.mypersonaldata.info') {
      baseUrl = 'https://api.mymip.be/API_devl/MipSoapAPI.asmx';
    }

    var token = false;
    var PaaSToken = false;
    var AuthenticationString = false;

    var vm = {};

    var apiCallNotifier = Util.createNotifier();
    vm.onAPICall = function (fn) {
      return apiCallNotifier.listen(fn);
    };

    vm.tokenInfo = function tokenInfo(token) {
      return vm.call('PaaSGetTokenInfo_t', {
        PaaSToken: token
      }, {
        1: 'warning.login.bad token'
      }).then(function (result) {
        return result.data
      });
    }

    vm.login = function login(token) {
      return vm.call('PaaSDoLoginWithToken_t', {
        PaaSToken: token
      }, {
        1: 'warning.login.bad login'
      }).then(function (session) {
        session.data.PaaSToken = token;
        return session.data;
      });
    }

    vm.loginWithCode = function loginWithCode(token, code) {
      return vm.call('PaaSDoLoginWithToken_t', {
        PaaSToken: token,
        AuthenticationString: code
      }, {
        1: 'warning.login.bad login'
      }).then(function (session) {
        session.data.PaaSToken = token;
        session.data.AuthenticationString = code;
        return session.data;
      });
    }

    function relogin(resume) {
      var d = $q.defer();

      vm.login(PaaSToken).then(function () {
        resume().then(d.resolve, d.reject);
      });

      return d.promise;
    }

    function keyForErrorCode(code, map) {
      if (code === -1) {
        return 'warning.unknown error';
      } else if (!map.hasOwnProperty(code)) {
        return 'warning.unmapped error';
      } else {
        return map[code];
      }
    }

    vm.setToken = function (newToken) {
      token = newToken;
    };

    vm.setPaaSToken = function (newToken) {
      PaaSToken = newToken;
    };

    vm.getPaaSToken = function () {
      return PaaSToken;
    };

    vm.setAuthenticationString = function (newString) {
      AuthenticationString = newString;
    };

    vm.getAuthenticationString = function () {
      return AuthenticationString;
    };


    vm.setLanguage = function setLanguage(language) {
      if (token) {
        return vm.call('setLanguage', {
          language: language
        });
      } else {
        return vm.noop();
      }
    }

    // remove attributes from primitive objects
    function unobjectifyPrimitives(data) {
      if (angular.isObject(data)) {
        var value = data.valueOf();
        if (!angular.isObject(value)) {
          return value;
        } else {
          Object.keys(data).forEach(function (key) {
            if (key === 'cmpeCode' && !data.hasOwnProperty('inOut') && data[key].hasOwnProperty('@inOut')) {
              data.inOut = data[key]['@inOut'];
            }
            data[key] = unobjectifyPrimitives(data[key]);
          });
          return data;
        }
      } else {
        return data;
      }
    }

    vm.call = function (method, data, errorCodeMappings, unobjectify, customXmlParser) {
      if (!errorCodeMappings) {
        errorCodeMappings = {
          4: 'api_err_invalid-session'
        };
      }

      // methods who don't have to be appended by _t
      var excludedMethods = [
        'PaaSDoLoginWithToken_t',
        'PaaSGetTokenInfo_t',
        'PaaSGetURL_t',
        'PaaSGetClient_t'
      ];

      if (token && excludedMethods.indexOf(method) === -1) {
        if (method.substr(method.length - 2) != "_t") {
          method = method + '_t';
        }

        if (angular.isUndefined(data)) {
          data = {};
        }

        data.token = token;

        if (angular.isUndefined(data.data)) {
          data.data = {};
        }

        if (PaaSToken) {
          data.data.PaaSToken = PaaSToken;
        }

        if (AuthenticationString) {
          data.data.AuthenticationString = AuthenticationString
        }

      }

      if (method === 'PaaSGetURL_t') {
        data.token = 'URI'
      }

      var d = $q.defer();
      apiCallNotifier.notify(method, data);
      var apiCall = {
        method: method,
        data: data
      };
      // broadcast start event
      $rootScope.$broadcast(SIGNAL_API_CALL_STARTED, apiCall);
      $soap.post(baseUrl, method, data, customXmlParser)
        .then(function (resp) {
          // some older methods return no returnStatus
          if (!angular.isObject(resp.returnStatus) &&
            angular.isNumber(resp.errorNumber) &&
            angular.isString(resp.errorMessage)) {

            resp.returnStatus = {
              errorNumber: resp.errorNumber,
              errorMessage: resp.errorMessage
            };
          }

          // ensure the method returned a returnStatus
          if (!angular.isObject(resp.returnStatus)) {
            var err = {
              errorNumber: -1,
              errorMessage: 'Missing returnStatus',
              errorKey: 'api_invalid-response',
              method: method,
              input: data,
              output: resp
            };
            $log.error('INVALID RESPONSE', err);
            toastr.error(err.errorMessage);
            d.reject(err);
          }
          // invalid sessions => relogin
          else if (resp.returnStatus.errorNumber === 4) {
            return relogin(function () {
              return vm.call(method, data, errorCodeMappings);
            });
          }
          // check if errorNumber indicates something other than success
          else if (
            (!customXmlParser && resp.returnStatus.errorNumber !== 0) ||
            (customXmlParser && angular.isObject(resp.returnStatus.errorNumber) && resp.returnStatus.errorNumber['#text'] !== '0')
          ) {
            $log.error('API.' + method + ' => ' +
              '[' + resp.returnStatus.errorNumber + '] ' +
              resp.returnStatus.errorMessage);
            resp.returnStatus.errorKey = keyForErrorCode(
              resp.returnStatus.errorNumber, errorCodeMappings);

            if (
              resp.returnStatus.errorNumber !== 102 &&
              resp.returnStatus.errorNumber !== 103 &&
              resp.returnStatus.errorNumber !== 104
            ) {
              toastr.error(resp.returnStatus.errorMessage);
            }
            d.reject(resp.returnStatus);
          }
          // simply return the API's response
          else {
            var message = '';
            if (customXmlParser && angular.isObject(resp.returnStatus.errorMessage)) {
              message = resp.returnStatus.errorMessage['#text'];
            } else {
              message = resp.returnStatus.errorMessage;
            }
            $log.info('API.' + method + ' => ' + message);
            if (unobjectify) {
              unobjectifyPrimitives(resp);
            }
            d.resolve(resp);
          }
        }, function (err) {
          // something else went wrong, most likely bad input
          $log.error('INVALID API CALL', {
            method: method,
            data: data,
            error: err
          });
          toastr.error('[INVALID API CALL]');
          d.reject({
            errorNumber: -1,
            errorMessage: '[INVALID API CALL]'
          });
        });
      // broadcast end event
      d.promise.finally(function () {
        $rootScope.$broadcast(SIGNAL_API_CALL_ENDED, apiCall);
      });
      return d.promise;
    };

    vm.noop = function noop() {
      return $q.when();
    };

    return vm;

  }).filter('sanitize4Soap', function () {
    // this filter will remove all null values from te given object, soapjs could not handle null objects. If you preserveKey === true all null's will be replaced by empty strings, recursive is default true
    return function (input, preserveKey, recursive, filterArrays, filterCreation) {
      input = angular.extend({}, input);
      if (angular.isUndefined(recursive)) recursive = true;
      return delete_null_properties(input, recursive, filterArrays, filterCreation);

      function delete_null_properties(input, recursive, filterArrays, filterCreation) {
        for (var i in input) {
          if (input[i] === null) {
            if (preserveKey) {
              input[i] = '';
            } else {
              delete input[i];
            }
          } else if (filterArrays && angular.isArray(input[i]) && input[i].length == 0) {
            delete input[i];
          } else if (filterCreation && i === "creation" || i === "created_by") {
            delete input[i];
          } else if (recursive && angular.isObject(input[i])) {
            delete_null_properties(input[i], recursive);
          }
        }
        return input
      }
    }

  });

angular.module('angularSoap', [])

.factory('$soap', function($q, $log, $window, xmlToJson){
  return {
    post: function(url, action, params, customXmlParser){
      var deferred = $q.defer();

      //Create SOAPClientParameters
      var soapParams = new $window.SOAPClientParameters();
      for(var param in params){
        soapParams.add(param, params[param]);
      }

      //Create Callback
      var soapCallback = function(e, rawXml){
        if (e.constructor.toString().indexOf("function Error()") != -1){
          deferred.reject("An error has occurred.");
        } else if (angular.isObject(customXmlParser)) {
          var json = xmlToJson.parse(rawXml, customXmlParser);
          deferred.resolve(json['soap:Envelope']['soap:Body'][action + 'Response'][action + 'Result']);
        } else {
          deferred.resolve(e);
        }
      }

      $window.SOAPClient.invoke(url, action, soapParams, true, soapCallback);

      return deferred.promise;
    },
    setCredentials: function(username, password){
      $window.SOAPClient.username = username;
      $window.SOAPClient.password = password;
    }
  }
})
// Changes XML to JSON
.factory('xmlToJson', function($document) {

  function tableToString(table) {
    var div = $document[0].createElement('div');
    div.appendChild(table);
    return div.innerHTML;
  }

  // Options can be an object with the key 'ignoreKeys'.
  // This key can be used to not parse some keys as json, but return them as a string.
  function parse(xml, options) {
    // Create the return object
    var obj = {};
    var ignoreKeys = [];

    if (angular.isDefined(options.ignoreKeys)) {
      ignoreKeys = options.ignoreKeys;
    }

    if (xml.nodeType == 1) { // element
      // do attributes
      if (xml.attributes.length > 0) {
      obj['@attributes'] = {};
        for (var j = 0; j < xml.attributes.length; j++) {
          var attribute = xml.attributes.item(j);
          obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType == 3) { // text
      obj = xml.nodeValue;
    }

    // do children
    if (xml.hasChildNodes()) {
      for(var i = 0; i < xml.childNodes.length; i++) {
        var item = xml.childNodes.item(i);
        var nodeName = item.nodeName;
        var doNotParseNode = (ignoreKeys.indexOf(nodeName) !== -1);

        if (typeof(obj[nodeName]) == 'undefined') {
          if (doNotParseNode) {
            obj[nodeName] = tableToString(item);
          } else {
            obj[nodeName] = parse(item, options);
          }
        } else {
          if (typeof(obj[nodeName].push) == 'undefined') {
            var old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          if (doNotParseNode) {
            obj[nodeName].push(tableToString(item));
          } else {
            obj[nodeName].push(parse(item, options));
          }
        }
      }
    }
    return obj;
  }

  return {
    parse: parse
  };
});

'use strict'

angular.module('privacy')
.directive('aclKey', function($log, Auth) {
  return {
    restrict: 'A',
    link: function($scope, element, attrs) {
      if (angular.isDefined(attrs.aclKey) && attrs.aclKey !== '') {
        if (!Auth.checkAccessList(attrs.aclKey)) {
          element.remove();
        }
      }
    }
  };
})
.directive('aclIf', function($log, Auth) {
  return {
    restrict: 'A',
    scope: {
      aclIf: '='
    },
    link: function($scope, element) {
      if (Auth.checkAccessList($scope.aclIf)) {
        element.remove();
      }
    }
  };
});

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.paasLogin', {
    url: '/login',
    params: {
      nextState: null,
      nextStateParams: null
    },
    templateUrl: 'app/paasLogin/paasLogin.html',
    controller: 'login_PaasloginController',
    controllerAs: 'login',
    resolve: {
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
})
.controller('login_PaasloginController', function(
  $state, Relen, $window,CustomElements, t, $rootScope, toastr
) {
  var vm = this;
  vm.data = '';

  if (angular.isUndefined($rootScope.firstTimeDefaultlangue)) {
    var lang = CustomElements.get('default_language');
    t.setLanguage(lang);
    $rootScope.firstTimeDefaultlangue = false;
  }

  vm.checkEmail = function() {
    if (validateEmail(vm.data)) {
      var data = {
        reltpID: null,
        email: vm.data,
        sentByEmail: false,
        application: 'Website'
      };

      Relen.getURL(data).then(function(result) {
        if(angular.isDefined(result) && angular.isDefined(result.URL)) {
          $window.location.href = result.URL;
        }

        if(angular.isDefined(result) && angular.isDefined(result.errorNumber)) {
          if(result.errorNumber === 102 || result.errorNumber === 104) {
            $state.go('privacy.unknown');
          } else if(result.errorNumber === 103) {
            $state.go('privacy.notUnique');
          }
        }
      });
    } else {
      toastr.error(t('login_privacy_email_not_valid'));
    }
  }

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
});

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.first_step', {
    url: '/privacy-login',
    params: {
      nextState: null,
      nextStateParams: null
    },
    controller: 'login_FirstController',
    controllerAs: 'login',
    resolve: {
      CLEAR: function($localStorage) {
        $localStorage.$reset();
      }
    }
  });
})
.controller('login_FirstController', function(
  $state, Relen, $localStorage
) {

  Relen.getClient().then(function(result){
    $localStorage['client'] = result.Client;
    $state.go('privacy.paasLogin');
  });

});

'use strict';

angular.module('privacy')
  .config(function ($stateProvider) {
    $stateProvider.state('privacy.main', {
      abstract: true,
      url: '/main',
      templateUrl: 'app/main/main.html',
      controller: 'main_MainController',
      controllerAs: 'main',
      resolve: {
        USER: function (Auth, ErrorService) {
          if (Auth.user || Auth.doLoginFromCache()) {
            return Auth.user;
          }
          return ErrorService.notLoggedIn();
        },
        APP: function (App) {
          return App.initialize();
        },
        CUSTOMTRANSLATIONS: function (CustomTranslations) {
          return CustomTranslations.promise();
        },
        CUSTOM2TRANSLATIONS: function (CustomTranslations) {
          return CustomTranslations.promise2();
        },
        CUSTOMSTYLE: function (CustomElements) {
          return CustomElements.promise();
        }
      }
    });
  })
  .controller('main_MainController', function (
    USER, t, PRIVACYVERSION, APP, $scope, Auth, $state, url, $window, $localStorage, CustomElements, $rootScope
  ) {
    var vm = this;

    angular.extend(vm, APP);

    var watcher = $scope.$watch(function () {
      return APP.contact;
    }, function (contact) {
      vm.contact = contact;

      if (vm.contact.hasOwnProperty('ContactIndividualEntity') && vm.contact.ContactIndividualEntity.hasOwnProperty('dob')) {
        vm.contact.ContactIndividualEntity.dobFormat = contact.ContactIndividualEntity.dob.format('DD/MM/YYYY');
      }
    }, true);

    vm.user = USER;
    vm.privacyVersion = PRIVACYVERSION;

    function getExtraTabs() {
      vm.extraTabs = [];
      CustomElements.getData().then(function (data) {
        if (data.hasOwnProperty('extra_tabs')) {
          if (data.extra_tabs.hasOwnProperty($localStorage['locale'])) {
            var value = angular.fromJson(data.extra_tabs[$localStorage['locale']]);
            angular.forEach(value, function (val) {
              if (val.hasOwnProperty('checkbox') && val.checkbox) {
                vm.extraTabs.push(val);
              }
            });
          }
        }
      });
    }

    getExtraTabs();

    vm.openTab = function openTab(tab) {
      $state.go('privacy.main.tab', {
        name: tab.name
      })
    };

    vm.logout = function logout() {
      var logoutUrl = url('logout_link');
      var useLink = url('logout_use_url');
      Auth.doLogout();
      if (useLink !== "1") {
        $state.go('privacy.logout');
      } else if (useLink === "1" && logoutUrl !== "") {
        $window.location.href = logoutUrl;
      } else {
        $state.go('privacy.logout');
      }
    };

    $scope.$on('$destroy', function () {
      watcher();
      watcherLang();
    })

    var watcherLang = $rootScope.$on('languageChanged', function () {
      getExtraTabs();
    });

  });

'use strict';

angular.module('privacy')
.config(function($stateProvider) {
  $stateProvider.state('privacy.login', {
    url: '/token/{token:.*}',
    params: {
      nextState: null,
      nextStateParams: null
    },
    controller: 'login_LoginController',
    controllerAs: 'login',
    resolve: {
      CLEAR: function($localStorage) {
        $localStorage.$reset();
      }
    }
  });
})
.run(function(Auth, $state, $log) {
  Auth.onSessionTimeout(function() {
    $log.debug('session timed out - going back to login');
    $state.go('privacy.login');
  });
})
.controller('login_LoginController', function(
  Auth, $state, $stateParams, $location, t
) {
  if ($stateParams.hasOwnProperty('token')) {
    Auth.getTokenInfo($stateParams.token).then(function(result) {
      if(!result) {
        doLoginWithoutCode();
      } else {
        $state.go('privacy.codeCheck', {
          token: $stateParams.token
        });
      }
    }, function () {
      $state.go('privacy.notAuthorized');
    });
  } else {
    $state.go('privacy.notAuthorized');
  }

  function doLoginWithoutCode() {
    Auth.doLogin($stateParams.token).then(function(data) {
      if (data.token) {
        var searchParams = $location.search();
        if (searchParams.hasOwnProperty('language')) {
          t.setLanguage(searchParams.language);
        }
        $state.go('privacy.main.data');
      } else {
        $state.go('privacy.notAuthorized');
      }
    }).catch(function() {
      $state.go('privacy.notAuthorized');
    });
  }
});

'use strict';

angular.module('privacy')
.constant('ERROR_TYPE_STATE', 'error_type_state')
.constant('ERROR_TYPE_UNKNOWN', 'error_type_unknown')
.constant('ERROR_NOT_LOGGED_IN', 'error_not_logged_in')
.constant('ERROR_NOT_AUTHORIZED', 'error_not_authorized')
.service('ErrorService',function($q, ERROR_NOT_LOGGED_IN, ERROR_NOT_AUTHORIZED) {
  var vm = {};

  vm.notLoggedIn = function() {
    return $q.reject({
      error: ERROR_NOT_LOGGED_IN
    });
  };

  vm.notAuthorized = function(aclKey) {
    return $q.reject({
      error: ERROR_NOT_AUTHORIZED,
      aclKey: aclKey
    });
  };

  return vm;
});

'use strict'

angular.module('privacy')
.run(function(
  $rootScope, $log, $state,
  ERROR_TYPE_STATE, ERROR_NOT_LOGGED_IN, ERROR_NOT_AUTHORIZED
) {
  // listen for state change problems
  var errorHandler = $rootScope.$on('$stateChangeError',function(
    evt, toState, toParams, fromState, fromParams, error
  ) {
    if(!angular.isObject(error)) {
      $log.error('invalid error passed:',error);
      error = {invalidError:error};
    }
    angular.extend(error, {
      type: ERROR_TYPE_STATE,
      toState:toState,
      toParams: toParams,
      fromState: fromState,
      fromParams: fromParams
    });
    $log.debug('$stateChangeError', error);
    if(error.error === ERROR_NOT_AUTHORIZED) {
      $state.go('privacy.notAuthorized', {
        aclKey: error.aclKey
      });
    } else if(toState.name !== 'privacy.error') {
      $log.debug('redirecting to privacy.error');
      $state.go('privacy.error',{error: error});
    } else if (error.error === ERROR_NOT_LOGGED_IN) {
      if(error.error === ERROR_NOT_LOGGED_IN) {
        $state.go('privacy.login', {
          nextState: toState,
          nextStateParams: toParams
        });
      }
    } else {
      $log.error('error state not reachable!');
    }
  });
  // cleanup $stateChangeError handler
  $rootScope.$on('$destroy', errorHandler);
})

'use strict';

angular.module('privacy')
.constant('LS_ERROR_PREVIOUS','error.previous')
.config(function($stateProvider) {
  $stateProvider.state('privacy.error', {
    // url: '/error',
    params: {
      error: null
    },
    templateUrl: 'app/error/error.html',
    controller: 'error_ErrorController',
    controllerAs: 'error',
    resolve: {
      CLIENT: function($localStorage) {
        if(angular.isUndefined($localStorage['client'])) {
          $localStorage['client'] = 'default';
        }
      },
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
  $stateProvider.state('privacy.notAuthorized', {
    url: '/not-authorized',
    templateUrl: 'app/error/not-authorized.html',
    controller: 'error_NotAuthorizedController',
    controllerAs: 'error',
    params: {
      aclKey: null
    },
    resolve: {
      CLIENT: function($localStorage) {
        if(angular.isUndefined($localStorage['client'])) {
          $localStorage['client'] = 'default';
        }
      },
      CUSTOMTRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise();
      },
      CUSTOM2TRANSLATIONS: function(CustomTranslations) {
        return CustomTranslations.promise2();
      },
      CUSTOMSTYLE: function(CustomElements) {
        return CustomElements.promise();
      }
    }
  });
})
.controller('error_ErrorController', function(
  $stateParams, $log, $state, $sessionStorage,
  LS_ERROR_PREVIOUS, $localStorage, Auth
) {

  var vm = this;

  var error = $stateParams.error || $sessionStorage[LS_ERROR_PREVIOUS];
  $sessionStorage[LS_ERROR_PREVIOUS] = error;
  angular.extend(vm,error);

  vm.back = function() {
    $log.debug('back to previous state');
    $state.go(error.fromState.name, error.fromParams);
  };

  vm.retry = function() {
    $log.debug('retrying errornous state');
    $state.go(error.toState.name, error.toParams);
  };

  vm.newCode = function() {
    Auth.getTokenInfo($localStorage['token']).then(function() {
      $sessionStorage.$reset()
      $state.go('privacy.codeCheck', {
        token: $localStorage['token']
      })
    });
  }

})
.controller('error_NotAuthorizedController', function($stateParams, $localStorage, Auth, $state) {
  var vm = this;
  vm.aclKey = $stateParams.aclKey;

  vm.newCode = function() {
    Auth.getTokenInfo($localStorage['token']).then(function() {
      $state.go('privacy.codeCheck', {
        token: $localStorage['token']
      })
    });
  }
});

'use strict';

angular.module('privacy')
.run(function($rootScope, $log) {
  // state change debugging
  function stringifyState(state, stateArgs) {
    return (state.name || '<BOOT>') + ' ' +
      angular.toJson(stateArgs);
  }

  var successListener = $rootScope.$on('$stateChangeSuccess', function(_evt, to, toArgs, from, fromArgs) {
    $log.info('state change: %s => %s',
      stringifyState(from, fromArgs),
      stringifyState(to, toArgs)
    );
  });

  var notFoundListener = $rootScope.$on('$stateNotFound', function(evt, unfoundState, from, fromArgs) {
    $log.warn('state not found', {
      evt: evt,
      unfoundState: unfoundState,
      from: from,
      fromArgs: fromArgs
    });
  });

  var errorListener = $rootScope.$on('$stateChangeError', function(evt, to, toArgs, from, fromArgs, error) {
    $log.warn('state change error: ' + from.name + ' => ' + to.name, {
      evt: evt,
      to: to,
      toArgs: toArgs,
      from: from,
      fromArgs: fromArgs,
      error: error
    });
  });

  $rootScope.$on('$destroy', function() {
    errorListener();
    successListener();
    notFoundListener();
  });

  $log.debug('Privacy Platform initialized');
});

'use strict';

angular.module('privacy').config(function(
  $stateProvider, $urlRouterProvider, $locationProvider
) {

  $stateProvider.state('privacy',{
    abstract:true,
    template:'<ui-view></ui-view>',
    controller: function($rootScope, t) {
      $rootScope.t = t;
    },
    controllerAs: 'privacy'
  });

  $urlRouterProvider.otherwise(function(injector, location) {
    var url = location.absUrl(),
        $window = injector.get('$window'),
        querystring = (url.indexOf('?') > 1)? url.slice(url.indexOf('?')) : undefined,
        redirect = '/not-authorized';

    if (querystring) {
      redirect += querystring;
      url = url.replace(querystring, '');
      // redirect with querystring behind the hashbang
      // remove if html 5 mode is enabled
      $window.location.href = url + '#' + redirect;
    }

    return redirect;

  });

  // cannot use html5mode + base tag for development
  $locationProvider.html5Mode(false);

});

"use strict";

angular
  .module("privacy")
  .constant("PRIVACYVERSION", "v1.0.18")
  .config(function ($logProvider, tmhDynamicLocaleProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    tmhDynamicLocaleProvider.localeLocationPattern(
      "i18n/angular-locale_{{locale}}.js"
    );
  })
  .service("moment", function ($window) {
    return $window.moment;
  });

angular.module("privacy").run(["$templateCache", function($templateCache) {$templateCache.put("app/error/error.html","<div class=\"error-view\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><h1><i class=\"sta-warning\"></i> {{t(\'error.title\')}}</h1><p>{{ t(\'error.text\') }}</p><p>{{ t(\'need_a_new_code_description\') }} <span ng-click=\"error.newCode()\">{{ t(\'need_a_new_code_click_here\') }}</span></p></div></div></div></div>");
$templateCache.put("app/error/not-authorized.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error.notAuthorized.title\') }}</h1><p>{{ t(\'error.notAuthorized.description\') }}</p><p ng-if=\"error.aclKey\">{{ t(\'error.notAuthorized.to {aclKey}\', {aclKey: error.aclKey}) }}</p><p>{{ t(\'need_a_new_code_description\') }} <span ng-click=\"error.newCode()\">{{ t(\'need_a_new_code_click_here\') }}</span></p></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/main.html","<ng-include src=\"\'app/main/elements/sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><ng-include src=\"\'app/main/elements/header.html\'\"></ng-include><ui-view></ui-view></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/paasLogin/paasLogin.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div customstyle=\"\" elements=\'{\"background\": \"main_background\"}\' class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'login_privacy_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'login_privacy_intro\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><form name=\"editForm\" class=\"check-code-form\" ng-submit=\"login.checkEmail()\" method=\"post\"><div class=\"form-group\"><input class=\"form-control\" type=\"text\" name=\"email\" id=\"email\" placeholder=\"{{ t(\'login_privacy_email\') }}\" ng-model=\"login.data\" autofocus=\"\"></div><button class=\"btn btn-primary pull-right\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'login_privacy_control_button\') }}</button></form></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/components/confirmation/confirm-remove.html","<div class=\"modal-body\"><h3 class=\"modal-title\">{{confirmation.question}}</h3><p>{{ confirmation.info }}</p></div><div class=\"modal-footer\"><button class=\"btn btn-link\" ng-click=\"$dismiss()\">{{ t(\'confirmation_cancel_btn\') }}</button> <button class=\"btn btn-primary\" ng-click=\"$close()\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'confirmation_confirm_remove_ok_btn\') }}</button></div>");
$templateCache.put("app/components/sidepanel/sidepanel.template.html","<pageslide ps-open=\"isOpen\" ps-key-listener=\"true\" ps-size=\"100%\" ps-custom-top=\"{{topVar}}\" ps-custom-bottom=\"46px\" ps-custom-height=\"auto\" ps-auto-close=\"true\" ps-body-class=\"slide-is-open\" ps-speed=\"0\"><div class=\"\"><div class=\"outer-page-slide\"><div class=\"inner-page-slide\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><a class=\"close\" ng-click=\"close()\" title=\"{{ t(\'main_cancel\') }}\"><i class=\"sta-cross\"></i></a><ng-transclude></ng-transclude></div></div></div></pageslide>");
$templateCache.put("app/components/templates/timepicker.html","<table class=\"uib-timepicker\"><tbody><tr class=\"text-center\" ng-show=\"::showSpinners\"><td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td>&nbsp;</td><td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td ng-show=\"showMeridian\"></td></tr><tr><td class=\"form-group uib-time hours\" ng-class=\"{\'has-error\': invalidHours}\"><input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\"></td><td class=\"uib-separator\">:</td><td class=\"form-group uib-time minutes\" ng-class=\"{\'has-error\': invalidMinutes}\"><input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\"></td><td ng-show=\"showSeconds\" class=\"uib-separator\">:</td><td class=\"form-group uib-time seconds\" ng-class=\"{\'has-error\': invalidSeconds}\" ng-show=\"showSeconds\"><input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\"></td><td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td></tr><tr class=\"text-center\" ng-show=\"::showSpinners\"><td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td>&nbsp;</td><td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td ng-show=\"showMeridian\"></td></tr></tbody></table>");
$templateCache.put("app/components/translation/lang-switch.html","<li class=\"dropdown\" uib-dropdown=\"\" ng-if=\"lang.languagesCount > 1\"><a href=\"#\" id=\"user-dropdown\" class=\"dropdown-toggle\" role=\"button\" uib-dropdown-toggle=\"\"><span class=\"inline-smaller\">{{ lang.languages[lang.locale] }} <span class=\"caret\"></span></span></a><ul class=\"uib-dropdown-menu\"><li ng-repeat=\"(locale, language) in lang.languages\"><a ng-click=\"lang.setLanguage(locale)\">{{ language }}</a></li></ul></li>");
$templateCache.put("app/login/codeCheck/codeCheck.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div customstyle=\"\" elements=\'{\"background\": \"main_background\"}\' class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'codeCheck_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'login_intro\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><form name=\"editForm\" class=\"check-code-form\" ng-submit=\"code.checkCode()\" method=\"post\"><div class=\"form-group\"><input class=\"form-control\" type=\"text\" name=\"code\" id=\"code\" placeholder=\"{{ t(\'codeCheck_description\') }}\" ng-model=\"code.data\" autofocus=\"\"></div><button class=\"btn btn-primary pull-right\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'codeCheck_check_code\') }}</button></form></div><p>{{ t(\'no_code_received_description\') }} <span ng-click=\"code.newCode()\">{{ t(\'no_code_received_click_here\') }}</span></p><br style=\"clear:both\"></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/login/logout/logout.html","<ng-include src=\"\'app/main/elements/logout_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1>{{ t(\'logout_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'logout_text\')\"></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/data/data.html","<div class=\"view view-data\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_my_data_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'my_data_intro\')\"></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><div ng-if=\"main.contact.ContactIndividualEntity\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_personal_data_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_personal_data\')\"></div><div ng-include=\"\'app/main/data/forms/update-individu.html\'\"></div></div><div class=\"touchpoints\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_touchpoints_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_contact_data\')\"></div><div class=\"table-responsive\"><table class=\"table touchpoints-table\" ng-if=\"data.touchPoints.length > 0\"><thead><tr><th><span>{{ t(\'main_data_touchpoints_touchpoint_type\') }}</span></th><th ng-if=\"data.showSubtypes\"><span>{{ t(\'main_data_touchpoints_touchpoint_subtype\') }}</span></th><th><span>{{ t(\'main_data_touchpoints_touchpoint_data\') }}</span></th></tr></thead><tbody><tr ng-repeat=\"tp in data.touchPoints | orderBy:[data.touchPointsOrder, \'-reltpSubCode\', \'-preferred\', \'-modification\']\"><td>{{ tp.reltpCode[\'@description\'] }}</td><td ng-if=\"data.showSubtypes\">{{ tp.reltpSubCode[\'@description\'] }}</td><td class=\"has-actions\">{{ data.touchpointValue(tp) }}<ul class=\"actions-menu\"><li acl-key=\"PAAS/Data/Touchpoint/Edit\" ng-if=\"tp.modify\"><a open-side=\"touchpoint-edit\" ng-click=\"data.editSideTouchpoint(tp)\" class=\"edit\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\'>{{ t(\'contacts_touchpoints_edit\') }}</a></li><li acl-key=\"PAAS/Data/Touchpoint/Delete\" ng-if=\"tp.delete\"><a ng-click=\"data.deleteTouchpoint(tp)\" class=\"delete\">{{ t(\'contacts_touchpoints_delete\') }}</a></li></ul></td></tr></tbody></table></div><div class=\"add-new-touchpoint-container\" ng-if=\"data.mainTypes.length > 0\"><h3 class=\"table-title\">{{ t(\'main_data_touchpoints_add_new_title\') }}</h3><a class=\"add-new\" open-side=\"touchpoint-create\" ng-click=\"data.createSideTouchpoint()\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\'>{{ t(\'contacts_touchpoints_add_touchpoint\') }}</a></div></div><div socialentity=\"\" class=\"social-entity\" ng-if=\"main.contact.ContactSocialEntity\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_social_entity_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_social_entity\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"form-control\"><span ng-if=\'main.contact.ContactSocialEntity.conseCode == \"COM\"\'>{{ t(\'main_data_social_entity_company\') }}</span> <span ng-if=\'main.contact.ContactSocialEntity.conseCode != \"COM\"\'>{{ t(\'main_data_social_entity_family\') }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-8\"><div class=\"form-control\"><span ng-if=\'main.contact.ContactSocialEntity.conseCode == \"COM\"\'>{{ main.contact.ContactSocialEntity.vat }}, {{ main.contact.ContactSocialEntity.legalFormCode[\'@description\'] }}, {{ main.contact.ContactSocialEntity.name }}</span> <span ng-if=\'main.contact.ContactSocialEntity.conseCode != \"COM\"\'>{{ main.contact.ContactSocialEntity.name }}</span></div></div></div><div class=\"cms-content info\">{{ t(\'main_data_social_entity_change_data\') }}</div></div></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"data.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div><div ng-include=\"\'app/main/data/sidepanels/touchpoint-create.html\'\"></div><div ng-include=\"\'app/main/data/sidepanels/touchpoint-edit.html\'\"></div>");
$templateCache.put("app/main/elements/default_sidebar.html","<section resize-sidebar=\"\" class=\"sidebar sidebar-default js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"c\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div><nav class=\"bottom-nav\"><ul><lang-switch></lang-switch></ul></nav></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/elements/footer.html","<footer resize-footer=\"\" customstyle=\"\" elements=\'{\"background\" : \"footer_background\", \"color\" : \"footer_color\"}\' class=\"footer js-footer\"><img customimage=\"\" elements=\"image_footer\" alt=\"\" class=\"footer-image\"><div class=\"footer-navigation\"><ul><li>&copy; {{ t(\'main_customer_name\') }}</li><li><a linkurl=\"\" urls=\"disclamer_link\" target=\"_blank\">{{ t(\'main_disclaimer\') }}</a></li><li><a linkurl=\"\" urls=\"privacy_link\" target=\"_blank\">{{ t(\'main_privacy\') }}</a></li><li>PAAS {{ main.privacyVersion }}{{ code.privacyVersion}}</li></ul></div></footer>");
$templateCache.put("app/main/elements/header.html","<header class=\"header\" menu=\"\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></header>");
$templateCache.put("app/main/elements/logout_sidebar.html","<section resize-sidebar=\"\" class=\"sidebar sidebar-default js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"c\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/elements/old_topmenu.html","<header class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container-fluid\"><div class=\"navbar-left\"><a href=\"#\" class=\"toggle-navigation js-toggle-nav\" role=\"button\" toggleside=\"\"><i class=\"sta-menu\"></i></a></div><div class=\"navbar-right\"><ul class=\"nav navbar-nav\"><lang-switch></lang-switch><li class=\"dropdown\"><a ng-click=\"main.logout()\">{{ t(\'main_topbar_logout\') }}</a></li></ul></div></div></header>");
$templateCache.put("app/main/elements/sidebar.html","<section resize-sidebar=\"\" class=\"sidebar js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"sidebar-menu-container\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div><nav role=\"navigation\" class=\"js-module-nav top-nav\"><ul><li><a>{{ t(\'custom_sidebar_welcome\') }} {{ main.contact.ContactIndividualEntity.firstName}}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.data\' | includedByState\" acl-key=\"PAAS/Data\"><a ui-sref=\"privacy.main.data\" title=\"{{t(\'custom_sidebar_data\')}}\">{{t(\'custom_sidebar_data\')}}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.permissions\' | includedByState\" acl-key=\"PAAS/Permissions\"><a ui-sref=\"privacy.main.permissions\" title=\"{{t(\'custom_sidebar_permissions\')}}\">{{t(\'custom_sidebar_permissions\')}}</a></li><li linkstyle=\"\" elements=\"tab.name\" ng-repeat=\"tab in main.extraTabs\"><a ng-click=\"main.openTab(tab)\" title=\"{{ tab.title }}\">{{ tab.title }}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.faq\' | includedByState\" acl-key=\"PAAS/Faq\"><a ui-sref=\"privacy.main.faq\" title=\"{{t(\'custom_sidebar_faq\')}}\">{{t(\'custom_sidebar_faq\')}}</a></li></ul></nav><nav class=\"bottom-nav js-bottom-nav\"><ul><lang-switch></lang-switch><li class=\"dropdown\"><a href=\"\" ng-click=\"main.logout()\">{{ t(\'custom_topbar_logout\') }}</a></li></ul></nav></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/faq/faq.html","<div class=\"view view-faq\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_faq_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'main_data_faq_text\')\"></div><div class=\"faq-overview\" match-height=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><nav class=\"js-module-subnav module-subnav faq-navigation\" scroll=\"\" customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><ul customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><li ng-repeat=\"tab in faq.tabs\" acl-key=\"{{tab.acl}}\" ng-class=\"{active: tab.title === faq.title}\" style=\"cursor:pointer\" ng-if=\"tab.checkbox\"><a ng-click=\"faq.openTab(tab)\">{{ tab.title_tab }}</a></li></ul></nav></div><div class=\"col-xs-12 col-sm-8\"><div class=\"js-module-subnav-content\"><div class=\"dashboards faq-content\" ng-if=\"!faq.error\" customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><h2>{{ (faq.title) }}</h2><div ng-bind-html=\"faq.description\"></div></div><div ng-if=\"faq.error\"><p ng-if=\"faq.error\">{{ t(\'faq.no dashboards found\') }}</p></div></div></div></div></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"faq.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div>");
$templateCache.put("app/main/permissions/permissions.html","<div class=\"view view-permissions\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_personal_permissions_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'my_comms_description\')\"></div><div class=\"permissions-legend-container\" ng-if=\"permissions.toggle.updated\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' legendhide=\"\"><h2 class=\"h4 permissions-legend-title\">{{ t(\'main_permissions_legend_title\') }}</h2><ul class=\"permission-legend-listing\"><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"permissions.toggle.disabled\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_disabled\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"permissions.toggle.unkown\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_unkown\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-model=\"permissions.toggle.good\" val-true=\"\'I\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_true\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-model=\"permissions.toggle.bad\" val-false=\"\'O\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_false\') }}</span></span></span></li></ul></div><div ng-if=\"main.contact.ContactPermissions\" class=\"permissions-container\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_personal_permissions_personal_data_title\') }}</h2><ul class=\"permission-listing\" ng-if=\"!permissions.useCategories\"><li ng-repeat=\"prb in permissions.permissionsGood\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul><ul class=\"permission-listing\" ng-if=\"permissions.useCategories\"><li ng-repeat=\"cat in permissions.permissionsCategory\" ng-if=\"cat.show\"><div class=\"clearfix\"><h3 class=\"pull-left\"><strong><u>{{ cat.title }}</u></strong></h3><span ng-if=\"cat.checkbox\" class=\"permission-toggle pull-left ml-1\"><nz-toggle tri-toggle=\"\" ng-model=\"cat.state\" on-toggle=\"permissions.editPermissionGroup(cat)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></div><p>{{ cat.description }}</p><span class=\"description-link\" uib-tooltip=\"{{ cat.description_permission }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\" ng-if=\"cat.permission_code != \'\'\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ cat.description_permission }}\"></i> <span ng-if=\"cat.title_permission !== \'\'\">{{ cat.title_permission }}</span> <span ng-if=\"cat.title_permission === \'\'\">{{ cat.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in cat.data.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul><ul class=\"list-unstyled\"><li ng-repeat=\"prb in cat.childeren\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul></li><li ng-repeat=\"prb in permissions.singlePermissions\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"permissions.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div>");
$templateCache.put("app/main/tab/tab.html","<h1>{{ tab.tab.title }}</h1><h2 ng-if=\"tab.tab.subtitle !=\'\'\">{{ tab.tab.subtitle }}</h2><div ng-bind-html=\"tab.tab.description1\" class=\"tab-description tab-description__top\"></div><h2 ng-if=\"tab.tab.titlelist !=\'\'\">{{ tab.tab.titlelist }}</h2><table class=\"table\"><thead><tr><th ng-repeat=\"header in tab.headers\"><span>{{ header.ColumnName }}</span></th></tr></thead><tbody><tr ng-repeat=\"row in tab.rows\"><td ng-repeat=\"header in tab.headers\"><span ng-if=\"header.ColumnType === \'html\'\" ng-bind-html=\"row[header.ColumnNumber]\"></span> <span ng-if=\"header.ColumnType !== \'html\'\">{{ row[header.ColumnNumber] }}</span></td></tr></tbody></table><div ng-bind-html=\"tab.tab.description2\" class=\"tab-description tab-description__bottom edit-container\"></div>");
$templateCache.put("app/paasLogin/notUnique/notUnique.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error_email_login_not_unique_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_unique_intro\')\"></div><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_unique_cs_data\')\"></div></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/paasLogin/unknown/unknown.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error_email_login_not_found_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_found_intro\')\"></div><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_found_cs_data\')\"></div></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/data/forms/default.html","<div class=\"form-group\" ng-if=\"data.showReltpSubCodes(data.sideTouchpoint.reltpCode)\"><label for=\"reltpSubCode\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_subtype\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpSubCode\" id=\"reltpSubCode\" ng-model=\"data.sideTouchpoint.reltpSubCode\" ng-options=\"subcode.tpSubCode as subcode.tpSubCodeDescription for subcode in data.getSubTypes(data.sideTouchpoint.reltpCode)\"></select></div></div><div class=\"form-group\"><label for=\"touchpoint-value\" class=\"control-label\">{{ data.sideTouchpointLabel }}</label> <input class=\"form-control\" name=\"value\" id=\"touchpoint-value\" type=\"text\" ng-model=\"data.sideTouchpoint.value\" required=\"\"></div>");
$templateCache.put("app/main/data/forms/post.html","<div class=\"form-group\" ng-if=\"data.showReltpSubCodes(data.sideTouchpoint.reltpCode)\"><label for=\"reltpSubCode\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_subtype\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpSubCode\" ng-model=\"data.sideTouchpoint.reltpSubCode\" ng-options=\"subcode.tpSubCode as subcode.tpSubCodeDescription for subcode in main.reltpCombinations.get(data.sideTouchpoint.reltpCode)\" ng-change=\"touchpoints.setPreferredLock(data.sideTouchpoint)\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label for=\"street\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_street\') }}</label> <input class=\"form-control\" type=\"text\" name=\"street\" id=\"street\" ng-model=\"data.sideTouchpoint.ContactAddress.street\"></div><div class=\"form-group col-sm-3\"><label for=\"housenr\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_housenr\') }}</label> <input class=\"form-control\" type=\"text\" name=\"housenr\" id=\"housenr\" ng-model=\"data.sideTouchpoint.ContactAddress.streetHouseNumber\"></div><div class=\"form-group col-sm-3\"><label for=\"complement\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_complement\') }}</label> <input class=\"form-control\" type=\"text\" name=\"complement\" id=\"complement\" ng-model=\"data.sideTouchpoint.ContactAddress.streetComplement\"></div><div class=\"form-group col-sm-6\"><label for=\"postal\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_postal_code\') }}</label> <input class=\"form-control\" type=\"text\" name=\"postal\" id=\"postal\" ng-model=\"data.sideTouchpoint.ContactAddress.postalCode\"></div><div class=\"form-group col-sm-6\"><label for=\"city\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_city\') }}</label> <input class=\"form-control\" type=\"text\" name=\"city\" id=\"city\" ng-model=\"data.sideTouchpoint.ContactAddress.city\"></div><div class=\"form-group col-sm-6\"><label for=\"country\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_country\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"country\" ng-model=\"data.sideTouchpoint.ContactAddress.countryCode\" ng-options=\"country.countryCode as country.description for country in main.countries.map\" required=\"\"></select></div></div></div>");
$templateCache.put("app/main/data/forms/update-individu.html","<form class=\"update-individu-form\" name=\"updateIndividu\" ng-submit=\"data.editIndividu()\" method=\"post\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\" acl-key=\"PAAS/Data/Contact/Edit/firstName\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_first_name\') }}</label><div mydata=\"\" data=\'{\"modify_firstname\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.firstName }}</div><input class=\"form-control\" type=\"text\" name=\"firstName\" id=\"firstName\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_first_name\') }}\" ng-model=\"data.sideIndividu.firstName\" mydata=\"\" data=\'{\"modify_firstname\": \"input\"}\'></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\" acl-key=\"PAAS/Data/Contact/Edit/familyName\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_family_name\') }}</label><div mydata=\"\" data=\'{\"modify_name\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.familyName }}</div><input class=\"form-control\" type=\"text\" name=\"familyName\" id=\"familysName\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_family_name\') }}\" ng-model=\"data.sideIndividu.familyName\" mydata=\"\" data=\'{\"modify_name\": \"input\"}\'></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_gender\') }}</label><div mydata=\"\" data=\'{\"modify_gender\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.genderDescription }}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_gender\": \"input\"}\'><select class=\"form-control\" name=\"gender\" id=\"gender\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_gender\') }}\" ng-model=\"data.sideIndividu.genderCode\" ng-options=\"gender.genderCode as gender.description for gender in data.genders\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_title\') }}</label><div mydata=\"\" data=\'{\"modify_title\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.titleDescription}}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_title\": \"input\"}\'><select class=\"form-control\" name=\"title\" id=\"title\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_title\') }}\" ng-model=\"data.sideIndividu.titleCode\" ng-options=\"title.titleCode as title.salutation for title in data.sideTitles()\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"language\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_language\') }}</label><div mydata=\"\" data=\'{\"modify_language\": \"div\"}\' class=\"form-control\">{{ main.languages.get(data.sideIndividu.languageCode).description }}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_language\": \"input\"}\'><select class=\"form-control\" name=\"language\" id=\"language\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_language\') }}\" ng-model=\"data.sideIndividu.languageCode\" ng-options=\"language.languageCode as language.description for language in main.languages.map\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"dob\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_date_of_birth\') }}</label><div mydata=\"\" data=\'{\"modify_dob\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.dob | date: \'dd/MM/yyyy\' }}</div><div class=\"input-group right-align\" mydata=\"\" data=\'{\"modify_dob\": \"input\"}\'><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-date\" ng-click=\"main.contact.ContactIndividualEntity.opened.dob = !touchpoints.sideIndividu.opened.dob\"><i customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' class=\"fa fa-calendar-full\"></i></button></span> <input type=\"text\" name=\"dob\" id=\"dob\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"main.contact.ContactIndividualEntity.opened.dob\" ng-model=\"data.sideIndividu.dob\" close-text=\"{{t(close)}}\" show-weeks=\"false\" show-button-bar=\"false\"></div></div></div></div><button class=\"btn btn-primary\" type=\"submit\" validation-tooltip=\"updateIndividu\" ng-disabled=\"updateIndividu.$invalid\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' mydatabutton=\"\">{{ t(\'contacts_touchpoints_manage_save\') }}</button></form>");
$templateCache.put("app/main/data/sidepanels/individu-edit.html","<side-panel open-by=\"individu-edit\" top-var=\"158px\"><h3>{{ t(\'contacts.touchpoints.manage.edit individual\') }}<br></h3><form name=\"updateIndividu\" ng-submit=\"data.editIndividu()\" method=\"post\"><div class=\"row\"><div class=\"form-group col-sm-6\" acl-key=\"PAAS/Data/Contact/Edit/firstName\"><label>{{ t(\'contacts.touchpoints.manage.individual.first name\') }}</label> <input class=\"form-control\" type=\"text\" name=\"firstName\" id=\"firstName\" ng-model=\"data.sideIndividu.firstName\"></div><div class=\"form-group col-sm-6\" acl-key=\"PAAS/Data/Contact/Edit/familyName\"><label>{{ t(\'contacts.touchpoints.manage.individual.family name\') }}</label> <input class=\"form-control\" type=\"text\" name=\"familyName\" id=\"familysName\" ng-model=\"data.sideIndividu.familyName\"></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.gender\') }}</label><select class=\"form-control\" name=\"gender\" id=\"gender\" ng-model=\"data.sideIndividu.genderCode\" ng-options=\"gender.genderCode as gender.description for gender in main.genders.map\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.title\') }}</label><select class=\"form-control\" name=\"title\" id=\"title\" ng-model=\"data.sideIndividu.titleCode\" ng-options=\"title.titleCode as title.salutation for title in data.sideTitles()\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.language\') }}</label><select class=\"form-control\" name=\"language\" id=\"language\" ng-model=\"data.sideIndividu.languageCode\" ng-options=\"language.languageCode as language.description for language in main.languages.map\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.date of birth\') }}</label><div class=\"input-group right-align\"><input type=\"text\" name=\"dob\" id=\"dob\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" placeholder=\"dd/mm/yyyy\" is-open=\"data.sideIndividu.opened.dob\" ng-model=\"data.sideIndividu.dob\" close-text=\"{{t(close)}}\" show-weeks=\"false\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"data.sideIndividu.opened.dob = !touchpoints.sideIndividu.opened.dob\"><i class=\"sta-calendar-full\"></i></button></span></div></div></div><br style=\"clear:both;\"><button class=\"btn btn-primary pull-right\" type=\"submit\" validation-tooltip=\"updateIndividu\" ng-disabled=\"updateIndividu.$invalid\">{{ t(\'contacts.touchpoints.manage.save\') }}</button></form></side-panel>");
$templateCache.put("app/main/data/sidepanels/touchpoint-create.html","<side-panel on-open=\"data.createSideTouchpoint()\" open-by=\"touchpoint-create\" top-var=\"158px\"><h3>{{ t(\'contacts_touchpoints_manage_touchpoint_add_touchpoint\') }}</h3><form name=\"createForm\" ng-submit=\"data.createTouchpoint()\" method=\"post\"><div class=\"form-group\"><label for=\"\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_add_touchpoint_code\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpCode\" ng-model=\"data.sideTouchpoint.reltpCode\" ng-options=\"code.reltpCode as code.description for code in data.mainTypes\"></select></div></div><div ng-if=\"data.sideTouchpoint.reltpCode\" ng-include=\"data.getTouchpointForm(data.sideTouchpoint)\"></div><button class=\"btn btn-primary pull-right\" ng-if=\"data.sideTouchpoint.reltpCode\" type=\"submit\" validation-tooltip=\"createForm\" ng-disabled=\"createForm.$invalid\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'contacts_touchpoints_manage_save\') }}</button></form></side-panel>");
$templateCache.put("app/main/data/sidepanels/touchpoint-edit.html","<side-panel open-by=\"touchpoint-edit\"><h3>{{ t(\'contacts_touchpoints_manage_touchpoint_edit_touchpoint\') }}</h3><form name=\"editForm\" ng-submit=\"data.editTouchpoint()\" method=\"post\"><div ng-include=\"data.getTouchpointForm(data.sideTouchpoint)\"></div><button class=\"btn btn-primary pull-right\" validation-tooltip=\"editForm\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' ng-disabled=\"editForm.$invalid\">{{ t(\'contacts_touchpoints_manage_save\') }}</button></form></side-panel>");
$templateCache.put("app/error/error.html","<div class=\"error-view\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><h1><i class=\"sta-warning\"></i> {{t(\'error.title\')}}</h1><p>{{ t(\'error.text\') }}</p><p>{{ t(\'need_a_new_code_description\') }} <span ng-click=\"error.newCode()\">{{ t(\'need_a_new_code_click_here\') }}</span></p></div></div></div></div>");
$templateCache.put("app/error/not-authorized.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error.notAuthorized.title\') }}</h1><p>{{ t(\'error.notAuthorized.description\') }}</p><p ng-if=\"error.aclKey\">{{ t(\'error.notAuthorized.to {aclKey}\', {aclKey: error.aclKey}) }}</p><p>{{ t(\'need_a_new_code_description\') }} <span ng-click=\"error.newCode()\">{{ t(\'need_a_new_code_click_here\') }}</span></p></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/main.html","<ng-include src=\"\'app/main/elements/sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><ng-include src=\"\'app/main/elements/header.html\'\"></ng-include><ui-view></ui-view></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/paasLogin/paasLogin.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div customstyle=\"\" elements=\'{\"background\": \"main_background\"}\' class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'login_privacy_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'login_privacy_intro\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><form name=\"editForm\" class=\"check-code-form\" ng-submit=\"login.checkEmail()\" method=\"post\"><div class=\"form-group\"><input class=\"form-control\" type=\"text\" name=\"email\" id=\"email\" placeholder=\"{{ t(\'login_privacy_email\') }}\" ng-model=\"login.data\" autofocus=\"\"></div><button class=\"btn btn-primary pull-right\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'login_privacy_control_button\') }}</button></form></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/components/confirmation/confirm-remove.html","<div class=\"modal-body\"><h3 class=\"modal-title\">{{confirmation.question}}</h3><p>{{ confirmation.info }}</p></div><div class=\"modal-footer\"><button class=\"btn btn-link\" ng-click=\"$dismiss()\">{{ t(\'confirmation_cancel_btn\') }}</button> <button class=\"btn btn-primary\" ng-click=\"$close()\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'confirmation_confirm_remove_ok_btn\') }}</button></div>");
$templateCache.put("app/components/sidepanel/sidepanel.template.html","<pageslide ps-open=\"isOpen\" ps-key-listener=\"true\" ps-size=\"100%\" ps-custom-top=\"{{topVar}}\" ps-custom-bottom=\"46px\" ps-custom-height=\"auto\" ps-auto-close=\"true\" ps-body-class=\"slide-is-open\" ps-speed=\"0\"><div class=\"\"><div class=\"outer-page-slide\"><div class=\"inner-page-slide\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><a class=\"close\" ng-click=\"close()\" title=\"{{ t(\'main_cancel\') }}\"><i class=\"sta-cross\"></i></a><ng-transclude></ng-transclude></div></div></div></pageslide>");
$templateCache.put("app/components/templates/timepicker.html","<table class=\"uib-timepicker\"><tbody><tr class=\"text-center\" ng-show=\"::showSpinners\"><td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td>&nbsp;</td><td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-up\"></i></a></td><td ng-show=\"showMeridian\"></td></tr><tr><td class=\"form-group uib-time hours\" ng-class=\"{\'has-error\': invalidHours}\"><input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\"></td><td class=\"uib-separator\">:</td><td class=\"form-group uib-time minutes\" ng-class=\"{\'has-error\': invalidMinutes}\"><input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\"></td><td ng-show=\"showSeconds\" class=\"uib-separator\">:</td><td class=\"form-group uib-time seconds\" ng-class=\"{\'has-error\': invalidSeconds}\" ng-show=\"showSeconds\"><input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\"></td><td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td></tr><tr class=\"text-center\" ng-show=\"::showSpinners\"><td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td>&nbsp;</td><td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><i class=\"fa fa-chevron-down\"></i></a></td><td ng-show=\"showMeridian\"></td></tr></tbody></table>");
$templateCache.put("app/login/codeCheck/codeCheck.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div customstyle=\"\" elements=\'{\"background\": \"main_background\"}\' class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'codeCheck_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'login_intro\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><form name=\"editForm\" class=\"check-code-form\" ng-submit=\"code.checkCode()\" method=\"post\"><div class=\"form-group\"><input class=\"form-control\" type=\"text\" name=\"code\" id=\"code\" placeholder=\"{{ t(\'codeCheck_description\') }}\" ng-model=\"code.data\" autofocus=\"\"></div><button class=\"btn btn-primary pull-right\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'codeCheck_check_code\') }}</button></form></div><p>{{ t(\'no_code_received_description\') }} <span ng-click=\"code.newCode()\">{{ t(\'no_code_received_click_here\') }}</span></p><br style=\"clear:both\"></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/components/translation/lang-switch.html","<li class=\"dropdown\" uib-dropdown=\"\" ng-if=\"lang.languagesCount > 1\"><a href=\"#\" id=\"user-dropdown\" class=\"dropdown-toggle\" role=\"button\" uib-dropdown-toggle=\"\"><span class=\"inline-smaller\">{{ lang.languages[lang.locale] }} <span class=\"caret\"></span></span></a><ul class=\"uib-dropdown-menu\"><li ng-repeat=\"(locale, language) in lang.languages\"><a ng-click=\"lang.setLanguage(locale)\">{{ language }}</a></li></ul></li>");
$templateCache.put("app/login/logout/logout.html","<ng-include src=\"\'app/main/elements/logout_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-login\"><h1>{{ t(\'logout_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'logout_text\')\"></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/elements/default_sidebar.html","<section resize-sidebar=\"\" class=\"sidebar sidebar-default js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"c\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div><nav class=\"bottom-nav\"><ul><lang-switch></lang-switch></ul></nav></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/elements/footer.html","<footer resize-footer=\"\" customstyle=\"\" elements=\'{\"background\" : \"footer_background\", \"color\" : \"footer_color\"}\' class=\"footer js-footer\"><img customimage=\"\" elements=\"image_footer\" alt=\"\" class=\"footer-image\"><div class=\"footer-navigation\"><ul><li>&copy; {{ t(\'main_customer_name\') }}</li><li><a linkurl=\"\" urls=\"disclamer_link\" target=\"_blank\">{{ t(\'main_disclaimer\') }}</a></li><li><a linkurl=\"\" urls=\"privacy_link\" target=\"_blank\">{{ t(\'main_privacy\') }}</a></li><li>PAAS {{ main.privacyVersion }}{{ code.privacyVersion}}</li></ul></div></footer>");
$templateCache.put("app/main/elements/header.html","<header class=\"header\" menu=\"\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></header>");
$templateCache.put("app/main/elements/logout_sidebar.html","<section resize-sidebar=\"\" class=\"sidebar sidebar-default js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"c\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/elements/old_topmenu.html","<header class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container-fluid\"><div class=\"navbar-left\"><a href=\"#\" class=\"toggle-navigation js-toggle-nav\" role=\"button\" toggleside=\"\"><i class=\"sta-menu\"></i></a></div><div class=\"navbar-right\"><ul class=\"nav navbar-nav\"><lang-switch></lang-switch><li class=\"dropdown\"><a ng-click=\"main.logout()\">{{ t(\'main_topbar_logout\') }}</a></li></ul></div></div></header>");
$templateCache.put("app/main/elements/sidebar.html","<section resize-sidebar=\"\" class=\"sidebar js-sidebar\" customstyle=\"\" elements=\'{\"background\": \"sidebar_background\", \"color\":\"sidebar_color\"}\'><div class=\"outer-sidebar js-outer-sidebar\"><div class=\"inner-sidebar\"><div class=\"sidebar-menu-container\"><button type=\"button\" name=\"button\" class=\"js-menu-button menu-button\"><span></span></button></div><div class=\"logo-container\"><img customimage=\"\" elements=\"logo\" src=\"\" alt=\"\" class=\"img-responsive\"></div><nav role=\"navigation\" class=\"js-module-nav top-nav\"><ul><li><a>{{ t(\'custom_sidebar_welcome\') }} {{ main.contact.ContactIndividualEntity.firstName}}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.data\' | includedByState\" acl-key=\"PAAS/Data\"><a ui-sref=\"privacy.main.data\" title=\"{{t(\'custom_sidebar_data\')}}\">{{t(\'custom_sidebar_data\')}}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.permissions\' | includedByState\" acl-key=\"PAAS/Permissions\"><a ui-sref=\"privacy.main.permissions\" title=\"{{t(\'custom_sidebar_permissions\')}}\">{{t(\'custom_sidebar_permissions\')}}</a></li><li linkstyle=\"\" elements=\"tab.name\" ng-repeat=\"tab in main.extraTabs\"><a ng-click=\"main.openTab(tab)\" title=\"{{ tab.title }}\">{{ tab.title }}</a></li><li linkstyle=\"\" elements=\"\'privacy.main.faq\' | includedByState\" acl-key=\"PAAS/Faq\"><a ui-sref=\"privacy.main.faq\" title=\"{{t(\'custom_sidebar_faq\')}}\">{{t(\'custom_sidebar_faq\')}}</a></li></ul></nav><nav class=\"bottom-nav js-bottom-nav\"><ul><lang-switch></lang-switch><li class=\"dropdown\"><a href=\"\" ng-click=\"main.logout()\">{{ t(\'custom_topbar_logout\') }}</a></li></ul></nav></div><img customimage=\"\" elements=\"image_sidebar\" alt=\"\" class=\"background-image\"></div></section>");
$templateCache.put("app/main/data/data.html","<div class=\"view view-data\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_my_data_title\') }}</h1><div class=\"intro-text\" ng-bind-html=\"t(\'my_data_intro\')\"></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' class=\"edit-container\"><div ng-if=\"main.contact.ContactIndividualEntity\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_personal_data_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_personal_data\')\"></div><div ng-include=\"\'app/main/data/forms/update-individu.html\'\"></div></div><div class=\"touchpoints\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_touchpoints_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_contact_data\')\"></div><div class=\"table-responsive\"><table class=\"table touchpoints-table\" ng-if=\"data.touchPoints.length > 0\"><thead><tr><th><span>{{ t(\'main_data_touchpoints_touchpoint_type\') }}</span></th><th ng-if=\"data.showSubtypes\"><span>{{ t(\'main_data_touchpoints_touchpoint_subtype\') }}</span></th><th><span>{{ t(\'main_data_touchpoints_touchpoint_data\') }}</span></th></tr></thead><tbody><tr ng-repeat=\"tp in data.touchPoints | orderBy:[data.touchPointsOrder, \'-reltpSubCode\', \'-preferred\', \'-modification\']\"><td>{{ tp.reltpCode[\'@description\'] }}</td><td ng-if=\"data.showSubtypes\">{{ tp.reltpSubCode[\'@description\'] }}</td><td class=\"has-actions\">{{ data.touchpointValue(tp) }}<ul class=\"actions-menu\"><li acl-key=\"PAAS/Data/Touchpoint/Edit\" ng-if=\"tp.modify\"><a open-side=\"touchpoint-edit\" ng-click=\"data.editSideTouchpoint(tp)\" class=\"edit\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\'>{{ t(\'contacts_touchpoints_edit\') }}</a></li><li acl-key=\"PAAS/Data/Touchpoint/Delete\" ng-if=\"tp.delete\"><a ng-click=\"data.deleteTouchpoint(tp)\" class=\"delete\">{{ t(\'contacts_touchpoints_delete\') }}</a></li></ul></td></tr></tbody></table></div><div class=\"add-new-touchpoint-container\" ng-if=\"data.mainTypes.length > 0\"><h3 class=\"table-title\">{{ t(\'main_data_touchpoints_add_new_title\') }}</h3><a class=\"add-new\" open-side=\"touchpoint-create\" ng-click=\"data.createSideTouchpoint()\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\'>{{ t(\'contacts_touchpoints_add_touchpoint\') }}</a></div></div><div socialentity=\"\" class=\"social-entity\" ng-if=\"main.contact.ContactSocialEntity\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_social_entity_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'my_data_social_entity\')\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"form-control\"><span ng-if=\'main.contact.ContactSocialEntity.conseCode == \"COM\"\'>{{ t(\'main_data_social_entity_company\') }}</span> <span ng-if=\'main.contact.ContactSocialEntity.conseCode != \"COM\"\'>{{ t(\'main_data_social_entity_family\') }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-8\"><div class=\"form-control\"><span ng-if=\'main.contact.ContactSocialEntity.conseCode == \"COM\"\'>{{ main.contact.ContactSocialEntity.vat }}, {{ main.contact.ContactSocialEntity.legalFormCode[\'@description\'] }}, {{ main.contact.ContactSocialEntity.name }}</span> <span ng-if=\'main.contact.ContactSocialEntity.conseCode != \"COM\"\'>{{ main.contact.ContactSocialEntity.name }}</span></div></div></div><div class=\"cms-content info\">{{ t(\'main_data_social_entity_change_data\') }}</div></div></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"data.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div><div ng-include=\"\'app/main/data/sidepanels/touchpoint-create.html\'\"></div><div ng-include=\"\'app/main/data/sidepanels/touchpoint-edit.html\'\"></div>");
$templateCache.put("app/main/faq/faq.html","<div class=\"view view-faq\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_faq_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'main_data_faq_text\')\"></div><div class=\"faq-overview\" match-height=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><nav class=\"js-module-subnav module-subnav faq-navigation\" scroll=\"\" customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><ul customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><li ng-repeat=\"tab in faq.tabs\" acl-key=\"{{tab.acl}}\" ng-class=\"{active: tab.title === faq.title}\" style=\"cursor:pointer\" ng-if=\"tab.checkbox\"><a ng-click=\"faq.openTab(tab)\">{{ tab.title_tab }}</a></li></ul></nav></div><div class=\"col-xs-12 col-sm-8\"><div class=\"js-module-subnav-content\"><div class=\"dashboards faq-content\" ng-if=\"!faq.error\" customstyle=\"\" elements=\'{ \"border-color\" : \"border_color\"}\'><h2>{{ (faq.title) }}</h2><div ng-bind-html=\"faq.description\"></div></div><div ng-if=\"faq.error\"><p ng-if=\"faq.error\">{{ t(\'faq.no dashboards found\') }}</p></div></div></div></div></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"faq.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div>");
$templateCache.put("app/main/tab/tab.html","<h1>{{ tab.tab.title }}</h1><h2 ng-if=\"tab.tab.subtitle !=\'\'\">{{ tab.tab.subtitle }}</h2><div ng-bind-html=\"tab.tab.description1\" class=\"tab-description tab-description__top\"></div><h2 ng-if=\"tab.tab.titlelist !=\'\'\">{{ tab.tab.titlelist }}</h2><table class=\"table\"><thead><tr><th ng-repeat=\"header in tab.headers\"><span>{{ header.ColumnName }}</span></th></tr></thead><tbody><tr ng-repeat=\"row in tab.rows\"><td ng-repeat=\"header in tab.headers\"><span ng-if=\"header.ColumnType === \'html\'\" ng-bind-html=\"row[header.ColumnNumber]\"></span> <span ng-if=\"header.ColumnType !== \'html\'\">{{ row[header.ColumnNumber] }}</span></td></tr></tbody></table><div ng-bind-html=\"tab.tab.description2\" class=\"tab-description tab-description__bottom edit-container\"></div>");
$templateCache.put("app/main/permissions/permissions.html","<div class=\"view view-permissions\"><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'>{{ t(\'main_data_personal_permissions_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'my_comms_description\')\"></div><div class=\"permissions-legend-container\" ng-if=\"permissions.toggle.updated\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\' legendhide=\"\"><h2 class=\"h4 permissions-legend-title\">{{ t(\'main_permissions_legend_title\') }}</h2><ul class=\"permission-legend-listing\"><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"permissions.toggle.disabled\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_disabled\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"permissions.toggle.unkown\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_unkown\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-model=\"permissions.toggle.good\" val-true=\"\'I\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_true\') }}</span></span></span></li><li class=\"permission-list-item\"><span class=\"permission-toggle\"><nz-toggle ng-model=\"permissions.toggle.bad\" val-false=\"\'O\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span class=\"permission-text\"><span class=\"display-table\"><span class=\"display-table-cell\">{{ t(\'main_permissions_toggle_false\') }}</span></span></span></li></ul></div><div ng-if=\"main.contact.ContactPermissions\" class=\"permissions-container\"><h2 customstyle=\"\" elements=\'{\"color\": \"subtitle_color\"}\'>{{ t(\'main_data_personal_permissions_personal_data_title\') }}</h2><ul class=\"permission-listing\" ng-if=\"!permissions.useCategories\"><li ng-repeat=\"prb in permissions.permissionsGood\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul><ul class=\"permission-listing\" ng-if=\"permissions.useCategories\"><li ng-repeat=\"cat in permissions.permissionsCategory\" ng-if=\"cat.show\"><div class=\"clearfix\"><h3 class=\"pull-left\"><strong><u>{{ cat.title }}</u></strong></h3><span ng-if=\"cat.checkbox\" class=\"permission-toggle pull-left ml-1\"><nz-toggle tri-toggle=\"\" ng-model=\"cat.state\" on-toggle=\"permissions.editPermissionGroup(cat)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></div><p>{{ cat.description }}</p><span class=\"description-link\" uib-tooltip=\"{{ cat.description_permission }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\" ng-if=\"cat.permission_code != \'\'\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ cat.description_permission }}\"></i> <span ng-if=\"cat.title_permission !== \'\'\">{{ cat.title_permission }}</span> <span ng-if=\"cat.title_permission === \'\'\">{{ cat.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in cat.data.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul><ul class=\"list-unstyled\"><li ng-repeat=\"prb in cat.childeren\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul></li><li ng-repeat=\"prb in permissions.singlePermissions\" class=\"permission-list-item\"><span class=\"description-link\" uib-tooltip=\"{{ t(prb.key) }}\" tooltip-placement=\"top\" tooltip-animation=\"false\" tooltip-popup-delay=\"0\"><i class=\"fa fa-0475-bubble-question\" id=\"{{ prb.key }}\"></i> <span ng-if=\"prb.title !== \'\'\">{{ prb.title }}</span> <span ng-if=\"prb.title === \'\'\">{{ prb.fallbackTitle }}</span></span><ul class=\"channel-listing\"><li ng-repeat=\"pr in prb.data\"><span class=\"channel-listing-item\"><span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-channel disabled\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide !== \'unkown\'\" class=\"permission-channel\"><i class=\"fa fa-{{ t(pr.icon) }}\"></i> <span>{{ t(pr.translation) }}</span></span> <span ng-if=\"pr.hide === \'false\'\" class=\"permission-toggle\"><nz-toggle val-default=\"\'?\'\" ng-model=\"pr.inOut\" val-false=\"\'O\'\" val-true=\"\'I\'\" on-toggle=\"permissions.editPermission(pr)\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'true\'\" class=\"permission-toggle\"><nz-toggle tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span> <span ng-if=\"pr.hide === \'unkown\'\" class=\"permission-toggle\"><nz-toggle ng-disabled=\"true\" tri-toggle=\"\" ng-model=\"pr.inOut\" on-toggle=\"permissions.editPermission(pr)\" val-false=\"\'O\'\" val-null=\"\'?\'\" val-true=\"\'I\'\" color-false=\"\'{{ permissions.colors.false }}\'\" color-true=\"\'{{ permissions.colors.true }}\'\"></nz-toggle></span></span></li></ul></li></ul></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"link\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div><a href=\"#\" class=\"btn btn-primary\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' linkurl=\"\" urls=\"cta_button_link\" target=\"_blank\" ng-click=\"permissions.tracking()\">{{ t(\'cta_button_text\') }}</a></div><div customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"cta_border_color\"}\' class=\"call-to-action\" ctahide=\"\" ctatype=\"default\"><h2 customstyle=\"\" elements=\'{\"color\": \"cta_color\"}\'>{{ t(\'cta_title\') }}</h2><div class=\"cms-content\" ng-bind-html=\"t(\'cta_description\')\"></div></div></div>");
$templateCache.put("app/paasLogin/notUnique/notUnique.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error_email_login_not_unique_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_unique_intro\')\"></div><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_unique_cs_data\')\"></div></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/paasLogin/unknown/unknown.html","<ng-include src=\"\'app/main/elements/default_sidebar.html\'\"></ng-include><div class=\"js-module-content module-content\"><div class=\"container-fluid\"><div class=\"view view-error\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"not-authorized\" customstyle=\"\" elements=\'{\"border-radius\" : \"border_radius\", \"border-color\" : \"border_color\"}\'><h1 customstyle=\"\" elements=\'{\"color\": \"title_color\"}\'><i class=\"sta-prohibited\"></i> {{ t(\'error_email_login_not_found_title\') }}</h1><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_found_intro\')\"></div><div class=\"cms-content\" ng-bind-html=\"t(\'error_email_login_not_found_cs_data\')\"></div></div></div></div></div></div></div><ng-include src=\"\'app/main/elements/footer.html\'\"></ng-include>");
$templateCache.put("app/main/data/forms/default.html","<div class=\"form-group\" ng-if=\"data.showReltpSubCodes(data.sideTouchpoint.reltpCode)\"><label for=\"reltpSubCode\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_subtype\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpSubCode\" id=\"reltpSubCode\" ng-model=\"data.sideTouchpoint.reltpSubCode\" ng-options=\"subcode.tpSubCode as subcode.tpSubCodeDescription for subcode in data.getSubTypes(data.sideTouchpoint.reltpCode)\"></select></div></div><div class=\"form-group\"><label for=\"touchpoint-value\" class=\"control-label\">{{ data.sideTouchpointLabel }}</label> <input class=\"form-control\" name=\"value\" id=\"touchpoint-value\" type=\"text\" ng-model=\"data.sideTouchpoint.value\" required=\"\"></div>");
$templateCache.put("app/main/data/forms/post.html","<div class=\"form-group\" ng-if=\"data.showReltpSubCodes(data.sideTouchpoint.reltpCode)\"><label for=\"reltpSubCode\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_subtype\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpSubCode\" ng-model=\"data.sideTouchpoint.reltpSubCode\" ng-options=\"subcode.tpSubCode as subcode.tpSubCodeDescription for subcode in main.reltpCombinations.get(data.sideTouchpoint.reltpCode)\" ng-change=\"touchpoints.setPreferredLock(data.sideTouchpoint)\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label for=\"street\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_street\') }}</label> <input class=\"form-control\" type=\"text\" name=\"street\" id=\"street\" ng-model=\"data.sideTouchpoint.ContactAddress.street\"></div><div class=\"form-group col-sm-3\"><label for=\"housenr\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_housenr\') }}</label> <input class=\"form-control\" type=\"text\" name=\"housenr\" id=\"housenr\" ng-model=\"data.sideTouchpoint.ContactAddress.streetHouseNumber\"></div><div class=\"form-group col-sm-3\"><label for=\"complement\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_complement\') }}</label> <input class=\"form-control\" type=\"text\" name=\"complement\" id=\"complement\" ng-model=\"data.sideTouchpoint.ContactAddress.streetComplement\"></div><div class=\"form-group col-sm-6\"><label for=\"postal\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_postal_code\') }}</label> <input class=\"form-control\" type=\"text\" name=\"postal\" id=\"postal\" ng-model=\"data.sideTouchpoint.ContactAddress.postalCode\"></div><div class=\"form-group col-sm-6\"><label for=\"city\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_city\') }}</label> <input class=\"form-control\" type=\"text\" name=\"city\" id=\"city\" ng-model=\"data.sideTouchpoint.ContactAddress.city\"></div><div class=\"form-group col-sm-6\"><label for=\"country\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_country\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"country\" ng-model=\"data.sideTouchpoint.ContactAddress.countryCode\" ng-options=\"country.countryCode as country.description for country in main.countries.map\" required=\"\"></select></div></div></div>");
$templateCache.put("app/main/data/forms/update-individu.html","<form class=\"update-individu-form\" name=\"updateIndividu\" ng-submit=\"data.editIndividu()\" method=\"post\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\" acl-key=\"PAAS/Data/Contact/Edit/firstName\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_first_name\') }}</label><div mydata=\"\" data=\'{\"modify_firstname\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.firstName }}</div><input class=\"form-control\" type=\"text\" name=\"firstName\" id=\"firstName\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_first_name\') }}\" ng-model=\"data.sideIndividu.firstName\" mydata=\"\" data=\'{\"modify_firstname\": \"input\"}\'></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\" acl-key=\"PAAS/Data/Contact/Edit/familyName\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_family_name\') }}</label><div mydata=\"\" data=\'{\"modify_name\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.familyName }}</div><input class=\"form-control\" type=\"text\" name=\"familyName\" id=\"familysName\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_family_name\') }}\" ng-model=\"data.sideIndividu.familyName\" mydata=\"\" data=\'{\"modify_name\": \"input\"}\'></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"gender\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_gender\') }}</label><div mydata=\"\" data=\'{\"modify_gender\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.genderDescription }}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_gender\": \"input\"}\'><select class=\"form-control\" name=\"gender\" id=\"gender\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_gender\') }}\" ng-model=\"data.sideIndividu.genderCode\" ng-options=\"gender.genderCode as gender.description for gender in data.genders\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_title\') }}</label><div mydata=\"\" data=\'{\"modify_title\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.titleDescription}}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_title\": \"input\"}\'><select class=\"form-control\" name=\"title\" id=\"title\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_title\') }}\" ng-model=\"data.sideIndividu.titleCode\" ng-options=\"title.titleCode as title.salutation for title in data.sideTitles()\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"language\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_language\') }}</label><div mydata=\"\" data=\'{\"modify_language\": \"div\"}\' class=\"form-control\">{{ main.languages.get(data.sideIndividu.languageCode).description }}</div><div class=\"select-wrapper\" customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' mydata=\"\" data=\'{\"modify_language\": \"input\"}\'><select class=\"form-control\" name=\"language\" id=\"language\" placeholder=\"{{ t(\'contacts_touchpoints_manage_individual_language\') }}\" ng-model=\"data.sideIndividu.languageCode\" ng-options=\"language.languageCode as language.description for language in main.languages.map\"></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"form-group\"><label for=\"dob\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_individual_date_of_birth\') }}</label><div mydata=\"\" data=\'{\"modify_dob\": \"div\"}\' class=\"form-control\">{{ data.sideIndividu.dob | date: \'dd/MM/yyyy\' }}</div><div class=\"input-group right-align\" mydata=\"\" data=\'{\"modify_dob\": \"input\"}\'><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-date\" ng-click=\"main.contact.ContactIndividualEntity.opened.dob = !touchpoints.sideIndividu.opened.dob\"><i customstyle=\"\" elements=\'{\"color\": \"link_color\"}\' class=\"fa fa-calendar-full\"></i></button></span> <input type=\"text\" name=\"dob\" id=\"dob\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"main.contact.ContactIndividualEntity.opened.dob\" ng-model=\"data.sideIndividu.dob\" close-text=\"{{t(close)}}\" show-weeks=\"false\" show-button-bar=\"false\"></div></div></div></div><button class=\"btn btn-primary\" type=\"submit\" validation-tooltip=\"updateIndividu\" ng-disabled=\"updateIndividu.$invalid\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' mydatabutton=\"\">{{ t(\'contacts_touchpoints_manage_save\') }}</button></form>");
$templateCache.put("app/main/data/sidepanels/individu-edit.html","<side-panel open-by=\"individu-edit\" top-var=\"158px\"><h3>{{ t(\'contacts.touchpoints.manage.edit individual\') }}<br></h3><form name=\"updateIndividu\" ng-submit=\"data.editIndividu()\" method=\"post\"><div class=\"row\"><div class=\"form-group col-sm-6\" acl-key=\"PAAS/Data/Contact/Edit/firstName\"><label>{{ t(\'contacts.touchpoints.manage.individual.first name\') }}</label> <input class=\"form-control\" type=\"text\" name=\"firstName\" id=\"firstName\" ng-model=\"data.sideIndividu.firstName\"></div><div class=\"form-group col-sm-6\" acl-key=\"PAAS/Data/Contact/Edit/familyName\"><label>{{ t(\'contacts.touchpoints.manage.individual.family name\') }}</label> <input class=\"form-control\" type=\"text\" name=\"familyName\" id=\"familysName\" ng-model=\"data.sideIndividu.familyName\"></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.gender\') }}</label><select class=\"form-control\" name=\"gender\" id=\"gender\" ng-model=\"data.sideIndividu.genderCode\" ng-options=\"gender.genderCode as gender.description for gender in main.genders.map\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.title\') }}</label><select class=\"form-control\" name=\"title\" id=\"title\" ng-model=\"data.sideIndividu.titleCode\" ng-options=\"title.titleCode as title.salutation for title in data.sideTitles()\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.language\') }}</label><select class=\"form-control\" name=\"language\" id=\"language\" ng-model=\"data.sideIndividu.languageCode\" ng-options=\"language.languageCode as language.description for language in main.languages.map\"></select></div><div class=\"form-group col-sm-6\"><label>{{ t(\'contacts.touchpoints.manage.individual.date of birth\') }}</label><div class=\"input-group right-align\"><input type=\"text\" name=\"dob\" id=\"dob\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" placeholder=\"dd/mm/yyyy\" is-open=\"data.sideIndividu.opened.dob\" ng-model=\"data.sideIndividu.dob\" close-text=\"{{t(close)}}\" show-weeks=\"false\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"data.sideIndividu.opened.dob = !touchpoints.sideIndividu.opened.dob\"><i class=\"sta-calendar-full\"></i></button></span></div></div></div><br style=\"clear:both;\"><button class=\"btn btn-primary pull-right\" type=\"submit\" validation-tooltip=\"updateIndividu\" ng-disabled=\"updateIndividu.$invalid\">{{ t(\'contacts.touchpoints.manage.save\') }}</button></form></side-panel>");
$templateCache.put("app/main/data/sidepanels/touchpoint-create.html","<side-panel on-open=\"data.createSideTouchpoint()\" open-by=\"touchpoint-create\" top-var=\"158px\"><h3>{{ t(\'contacts_touchpoints_manage_touchpoint_add_touchpoint\') }}</h3><form name=\"createForm\" ng-submit=\"data.createTouchpoint()\" method=\"post\"><div class=\"form-group\"><label for=\"\" class=\"control-label\">{{ t(\'contacts_touchpoints_manage_touchpoint_add_touchpoint_code\') }}</label><div class=\"select-wrapper\"><select class=\"form-control\" name=\"reltpCode\" ng-model=\"data.sideTouchpoint.reltpCode\" ng-options=\"code.reltpCode as code.description for code in data.mainTypes\"></select></div></div><div ng-if=\"data.sideTouchpoint.reltpCode\" ng-include=\"data.getTouchpointForm(data.sideTouchpoint)\"></div><button class=\"btn btn-primary pull-right\" ng-if=\"data.sideTouchpoint.reltpCode\" type=\"submit\" validation-tooltip=\"createForm\" ng-disabled=\"createForm.$invalid\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\'>{{ t(\'contacts_touchpoints_manage_save\') }}</button></form></side-panel>");
$templateCache.put("app/main/data/sidepanels/touchpoint-edit.html","<side-panel open-by=\"touchpoint-edit\"><h3>{{ t(\'contacts_touchpoints_manage_touchpoint_edit_touchpoint\') }}</h3><form name=\"editForm\" ng-submit=\"data.editTouchpoint()\" method=\"post\"><div ng-include=\"data.getTouchpointForm(data.sideTouchpoint)\"></div><button class=\"btn btn-primary pull-right\" validation-tooltip=\"editForm\" type=\"submit\" customstyle=\"\" elements=\'{ \"background\" : \"button_background_color\", \"color\" : \"button_text_color\", \"border-radius\" : \"border_radius\",\"border-color\" : \"button_border_color\"}\' ng-disabled=\"editForm.$invalid\">{{ t(\'contacts_touchpoints_manage_save\') }}</button></form></side-panel>");}]);